(function () {
  "use strict";

  angular
    .module("digitalLeasing.module", [])

    .component("digitalLeasing", {
      templateUrl: "ng/components/digitalLeasing/digitalLeasing.view.html",
      bindings: {},
      controllerAs: "DigitalLeasingCtrl",
      controller: function DigitalLeasingController(
        $digitalService,
        $portalService,
        $configService,
        $storageService,
        $financialApiService,
        $rootScope,
        $transactionFactory,
        $download
      ) {
        var self = this;

        self.supportModel = {
          clientList: [],
        };
        self.$digitalService = $digitalService;
        self.$portalService = $portalService;
        self.$rootScope = $rootScope;
        self.$onInit = function () {
          self.newAdvEnabled = $configService.getAppConfig().envData.newAdvEnabled;
          self.model = $digitalService.initModel();
          $digitalService.setFilterIsPresent($transactionFactory.getFilters());
          console.info("initialized model as: ", self.model);
          if ($digitalService.getWizardMap(self.model.viewIndex) == "M1") {
            $digitalService.navigator.enabled.enabledBack = false;
            $digitalService.navigator.enabled.enabledSave = false;
            $financialApiService
              .progressBar()
              .then(function (response) {
                $digitalService.navigator.progressBar =
                  response.frontEndOptions.progressBar;
                $digitalService.navigator.actionBar =
                  response.frontEndOptions.actionBar;
              })
              .catch(function (e) {
                console.log("Errore nel servizio", e);
              });
          }
        };

        self.$onChanges = function (changes) {
          console.log("model changed! :", changes);
        };

        self.isCervedDataOk = function (isCervedDataOk) {
          if (isCervedDataOk) {
            self.dataFromCervedReturned = true;
          } else {
            self.dataFromCervedReturned = false;
          }
        };

        self.exportValueModal = function (label, textValue, actionSelected) {
          self.actionSelected = actionSelected;
          switch (actionSelected) {
            case "NEXT":
              self.txtValue = textValue;
              self.lblAction = label;
              break;
            case "APPROVE":
              self.txtValue = "";
              self.lblAction = "LBL_DEROGA_APPROVED";
              break;
            case "REQUEST_CORRECTION":
              self.txtValue = textValue;
              self.lblAction = label;
              break;
            case "CUSTOMER_CARE":
              self.txtValue = "";
              self.txtValue = textValue;
              self.lblAction = label;
              break;
            default:
              break;
          }
        };
      },
    })

    .factory(
      "$digitalService",
      function (
        $workflowService,
        FinancialModel,
        $financialApiService,
        $transactionFactory,
        $modalService,
        $location,
        $userService,
        $simulationService,
        $rootScope,
        $portalService,
        $instantService,
        $privacyService,
        FinancialCustomer,
        FinancialVendor,
        Bank,
        LeasingData,
        RiUserG,
        DettaglioDeroga,
        $timeout,
        $storageService,
        $notificationService,
        $configService,
        QuestionarioBei,
        FileUploader,
        Residenza,
        $uniService,
        $download,
        $giuridicVersion
      ) {
        var $rootScope = $rootScope;
        var financialModel;
        var enableFinancialData;
        var enableLeasingHypothensis;
        var enableSettingProductsRange;
        var enalbeMPLPage;
        var enableCorporateData;
        var enableGoodManagement;
        var enableFinancialCustomer;
        var enableClientData;
        var enableButtonCheckList;
        var enableButtonCheckContacts;
        var enableButtonFatturazione;
        var type = "WF_DIGITAL";
        var responsecheckDeroga = {};
        var responseCheckRichiesta = {};
        var acceptMode = false;
        var searchMode = false;
        var enableNuovoPrestoLeasing;
        var enableDerogationsManage;
        var enableRatingCgs;
        var enableNpl;
        var noteAlba = "";
        var enableButtonCespite;
        var loader = false;
        var enabledButtons = true;
        var enableButtonInContractSignaturePage = false;
        var enableFondiBei = false;
        var modelQuestionarioBei = null;
        var enableAliquota;
        var listOfDocumentNotUploaded = [];
        var enableButtonClientiDest = false;
        var enableButtonIbanAuth = false;
        var enableButtonAdvSubject = false;
        var modelQuestAdv = {};
        var newAddedQuestAdv = {};
        var valueForEnabledNextButton = false;
        var enableButtonTax = false;
        var enabledCcs = false;
        var userInfo = $configService.getUser();
        var responseCheckGarante = {};
        var infoQVA = {};
        var filtersIsPresent = {}
        var enableButtonIban = false;
        var backgroundPrint = true;
        var enableMPLPage = true;
        var responseSubmitLoadContract = {};
        var responsecheckSubmitDelBanca = {};
        var responseValidateADV = {};
        var showHideNextButtonM17 = true;
        var enableDNPLPage = true;
        var enableButtonRiskCourse = false;

        var initModel = function () {
          financialModel = $transactionFactory.get() || FinancialModel.build();
          navigator.enabled.enabledNext =
            (financialModel.frontEndOptions &&
              financialModel.frontEndOptions.disableNext) || false;
          navigator.enabled.enabledBack =
            (financialModel.frontEndOptions &&
              !financialModel.frontEndOptions.disabledBack);
          navigator.enabled.enabledSave =
            (financialModel.frontEndOptions &&
              !financialModel.frontEndOptions.disabledSave);
          navigator.progressBar =
            financialModel.frontEndOptions &&
            financialModel.frontEndOptions.progressBar;
          navigator.actionBar =
            financialModel.frontEndOptions &&
            financialModel.frontEndOptions.actionBar;
          var storageService = $storageService;
          if (!$transactionFactory.get()) {
            var idSelected = localStorage.getItem("IdIconSelected");
            financialModel.viewIndex = parseInt(
              storageService.getAppConfig().permissions.uniFeMap[
                idSelected
              ].viewIndex
            );
            localStorage.removeItem("IdIconSelected");
          }
          $transactionFactory.clear();
          return financialModel;
        };

        var getWizardMap = function (viewIndex) {
          if (
            $rootScope.wizardMap.find(function (element) {
              return element.index == viewIndex;
            })
          ) {
            return $rootScope.wizardMap.find(function (element) {
              return element.index == viewIndex;
            }).viewName;
          }
        };

        var getModel = function () {
          if (financialModel) {
            return financialModel;
          } else {
            financialModel = initModel();
            return financialModel;
          }
        };

        var setModel = function (model) {
          financialModel = FinancialModel.build(model);
        };

        var validateFinancialData = function (value) {
          enableFinancialData = value;
        };

        var validateLeasingHypothesis = function (value) {
          enableLeasingHypothensis = value;
        };

        var validateBancaPrestoLeasing = function (value) {
          enableMPLPage = value;
        }

        var validateCorporateData = function (value) {
          enableCorporateData = value;
        };

        var validateGoodManagement = function (value) {
          enableGoodManagement = value;
        };

        var setChecDeroga = function (value) {
          responsecheckDeroga = value;
        };

        var getChecDeroga = function () {
          return responsecheckDeroga;
        };

        var validateSettingProductsRange = function (value) {
          enableSettingProductsRange = value;
        };

        var validateFinancialCustomer = function (value) {
          enableFinancialCustomer = value;
        };

        var getAcceptMode = function () {
          return acceptMode;
        };

        var setAcceptMode = function (value) {
          acceptMode = value;
          $modalService.closeModal("preventive-accept-modal");
        };

        var getPortalName = function () {
          return $portalService.isAru();
        };

        var getCheckRichiesta = function () {
          return responseCheckRichiesta;
        };

        var setCheckRichiesta = function (value) {
          responseCheckRichiesta = value;
        };

        var getCheckGarante = function () {
          return responseCheckGarante;
        };

        var setCheckGarante = function (value) {
          responseCheckGarante = value;
        };

        var validateCheckList = function (value) {
          enableButtonCheckList = value;
        };

        var validateNuovoPrestoLeasing = function (value) {
          enableNuovoPrestoLeasing = value;
        };

        var validateCheckContacts = function (value) {
          enableButtonCheckContacts = value;
        };

        var validateFatturazione = function (value) {
          enableButtonFatturazione = value;
        };

        var validateDerogationsManage = function (value) {
          enableDerogationsManage = value;
        };

        var validateCespite = function (value) {
          enableButtonCespite = value;
        };

        var validateRatingCgs = function (value) {
          enableRatingCgs = value;
        };

        var validateClientData = function (value) {
          enableClientData = value;
        };

        var validateNpl = function (value) {
          enableNpl = value;
        };

        var validateDnpl = function (value) {
          enableDNPLPage = value;
        };

        var validityFondiBei = function (value) {
          enableFondiBei = value;
        };

        var validateRecClient = function (value) {
          enableButtonClientiDest = value;
        };

        var validateIban = function (value) {
          enableButtonIban = value;
        };


        var validateIbanAuth = function (value) {
          enableButtonIbanAuth = value;
        };

        var validateAdvSubject = function (value) {
          enableButtonAdvSubject = value;
        };

        var valueOfQuestADV = function (questAdv, enableNextButton, newAdded) {
          modelQuestAdv = questAdv;
          valueForEnabledNextButton = enableNextButton;
          newAddedQuestAdv = newAdded;

        }

        var validateTax = function (value) {
          enableButtonTax = value;
        };

        var validateCcs = function (value) {
          enabledCcs = value;
        };

        var setFondiBei = function (value) {
          enableFondiBei = value;
        };

        var getFondiBei = function () {
          return enableFondiBei;
        };

        var setNoteAlba = function (value) {
          noteAlba = value;
        };

        var getNoteAlba = function () {
          return noteAlba;
        };

        var getSearchMode = function () {
          return acceptMode;
        };

        var setSearchMode = function (value) {
          searchMode = value;
        };

        var setLoader = function (value) {
          loader = value;
        };

        var getLoader = function () {
          return loader;
        };

        var setEnabledButtons = function (value) {
          enabledButtons = value;
        };

        var getEnabledButtons = function () {
          return enabledButtons;
        };

        var getListOfDocumentNotUploaded = function () {
          return listOfDocumentNotUploaded;
        };

        var setListOfDocumentNotUploaded = function (value) {
          listOfDocumentNotUploaded = value;
        };

        var validateAliquota = function (value) {
          enableAliquota = value;
        };

        var setQvaInfo = function (value) {
          infoQVA = value;
        }

        var getQvaInfo = function () {
          return infoQVA;
        }

        var setResponseSubmitLoadContract = function (value) {
          responseSubmitLoadContract = value;
        }

        var getResponseSubmitLoadContract = function () {
          return responseSubmitLoadContract;
        }

        var setResponsecheckSubmitDelBanca = function (value) {
          responsecheckSubmitDelBanca = value;
        }

        var getResponsecheckSubmitDelBanca = function () {
          return responsecheckSubmitDelBanca;
        }

        var changeRadioAction = function (valore) {
          var model = getModel();
          model.leasingData.preventivo.dettaglioDeroga.tipoAzione = valore;
          setModel(model);
        }

        var setResponseValidateADV = function (valore) {
          responseValidateADV = valore;
        }

        var getResponseValidateADV = function () {
          return responseValidateADV;
        }

        var getModelQuestAdv = function () {
          return modelQuestAdv;
        }
		
		var isSlimLeasing = function () {
			var model = getModel();
		 	return model.leasingData.preventivo.slimLeasing;
		};

        var submitDeroga = function () {
          setLoader(true);
          setEnabledButtons(false);

          $workflowService.checkConcurrence(financialModel.idWfInstance)
            .then(function (response) {
              if (response.success) {
                $workflowService
                  .submitDeroga(FinancialModel.build(financialModel), type)
                  .then(function (response) {
                    if (response.success) {
                      $modalService.closeModal("modalConfirmDeroga");
                      setLoader(false);
                      setEnabledButtons(true);
                      $location.path("/");
                    } else {
                      setLoader(false);
                      setEnabledButtons(true);
                    }
                  })
                  .catch(function (error) {
                    setLoader(false);
                    setEnabledButtons(true);
                    console.log("error", error);
                  });

              } else {
                setLoader(false);
                setEnabledButtons(true);
                console.log("error", error);
              }
            })
            .catch(function (error) {
              setLoader(false);
              setEnabledButtons(true);
              console.log("error", error);
            })
        };

        var submitRating = function (idModal) {
          $rootScope.$broadcast("pageLoader", {
            action: "OPEN",
          });
          $financialApiService
            .sendAccept(FinancialModel.build(financialModel), type, true)
            .then(function (response) {
              if (response.success) {
                if (response.goHome) {
                  $modalService.closeModal(idModal);
                  $location.path("/");
                } else {
                  var snapshot = response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
                  var metadata = JSON.parse(snapshot.metadata);
                  var modelAfterSendAccept = FinancialModel.build(metadata.dynamicInputPojo);

                  $workflowService
                    .nextStep(FinancialModel.build(modelAfterSendAccept), type, true, modelAfterSendAccept.taskFiliale)
                    .then(function (response) {
                      setLoader(false);
                      setEnabledButtons(true);
                      $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE",
                      });
                      financialModel = response;
                      $modalService.closeModal(idModal);
                      $location.path("/digitalLeasing");
                    })
                    .catch(function () {
                      setLoader(false);
                      setEnabledButtons(true);
                      $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE",
                      });
                    });
                }
              } else {
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              }
            })
            .catch(function () {
              setLoader(false);
              setEnabledButtons(true);
              $rootScope.$broadcast("pageLoader", {
                action: "CLOSE",
              });
            });
        };

        var submitRichiestaPlafond = function () {
          navigator.loading.nextStep = true;
          $financialApiService
            .submitRichiestaPlafond(FinancialModel.build(financialModel), type)
            .then(function (response) {
              if (response.success) {
                $location.path("/");
                navigator.loading.nextStep = false;
              } else {
                navigator.loading.nextStep = false;
              }
            })
            .catch(function (error) {
              console.log(error);
              navigator.loading.nextStep = false;
            });
        };

        var modelQuestionarioBei = function (model) {
          modelQuestionarioBei = model;
        };

        var validateContractSignaturePage = function (valore) {
          enableButtonInContractSignaturePage = valore;
        };

        var setShowHideNextButton = function (valore) {
          showHideNextButtonM17 = valore
        }

        var getShowHideNextButton = function () {
          if (getWizardMap(financialModel.viewIndex) == 'M17' && $portalService.isAra()) {
            return showHideNextButtonM17;
          } else {
            return true;
          }

        }

        var enableNextRiskCourse = function (value) {
          enableButtonRiskCourse = value;
        }

        var gotoHomeWithFilter = function () {
          $rootScope.returnToHomeWithFilters = true;
          $location.path("/");
        }

        var addNewValueIntoModelADV = function () {
          if (newAddedQuestAdv.nuoviTitolari && newAddedQuestAdv.nuoviTitolari.length) {

            newAddedQuestAdv.nuoviTitolari.forEach(function (element) {
              var checkCfIsPresent = modelQuestAdv.metadataAdv.titolari.titolari.some(function (titolare) {
                return titolare.cf == element.cf
              })
              if (!checkCfIsPresent) {
                modelQuestAdv.metadataAdv.titolari.titolari.push(element)
              }
            })
          }

          if (newAddedQuestAdv.nuoviEsecutori && newAddedQuestAdv.nuoviEsecutori.length) {

            newAddedQuestAdv.nuoviEsecutori.forEach(function (element) {
              var checkCfIsPresent = modelQuestAdv.metadataAdv.esecutori.esecutori.some(function (titolare) {
                return titolare.cf == element.cf
              })
              if (!checkCfIsPresent) {
                modelQuestAdv.metadataAdv.esecutori.esecutori.push(element)
              }
            })
          }

          if (newAddedQuestAdv.nuoveFiduciarie && newAddedQuestAdv.nuoveFiduciarie.length) {
            if (!modelQuestAdv.metadataAdv.fiduciarie) {
              modelQuestAdv.metadataAdv.fiduciarie = {
                fiduciarie: []
              }
            }
            modelQuestAdv.metadataAdv.fiduciarie.fiduciarie = modelQuestAdv.metadataAdv.fiduciarie.fiduciarie.concat(newAddedQuestAdv.nuoveFiduciarie);

            newAddedQuestAdv.nuoveFiduciarie.forEach(function (element) {
              var checkCfIsPresent = modelQuestAdv.metadataAdv.fiduciarie.fiduciarie.some(function (titolare) {
                return titolare.cf == element.cf
              })
              if (!checkCfIsPresent) {
                modelQuestAdv.metadataAdv.fiduciarie.fiduciarie.push(element)
              }
            })
          }

          if (newAddedQuestAdv.nuovoFiduciante && newAddedQuestAdv.nuovoFiduciante.length) {
            if (!modelQuestAdv.metadataAdv.fiducianti) {
              modelQuestAdv.metadataAdv.fiducianti = {
                fiducianti: []
              }
            }
            newAddedQuestAdv.nuovoFiduciante.forEach(function (element) {
              var checkCfIsPresent = modelQuestAdv.metadataAdv.fiducianti.fiducianti.some(function (titolare) {
                return titolare.cf == element.cf
              })
              if (!checkCfIsPresent) {
                modelQuestAdv.metadataAdv.fiducianti.fiducianti.push(element)
              }
            })
          }

        }


        /**
         * Navigation
         */
        var navigator = {
          loading: {
            backStep: false,
            nextStep: false,
            suspend: false,
            suspension: false
          },
          enabled: {
            enabledBack: false,
            enabledSave: false,
            enabledNext: false
          },
          progressBar: [],
          actionBar: [],
          somethingLoading: function () {
            var self = this;
            var some = false;
            Object.keys(self.loading).forEach(function (value) {
              if (self.loading[value] == true) {
                some = true;
              }
            });
            return some;
          },
          getPageIndex: function () {
            return parseInt(financialModel.viewIndex);
          },
          nextPage: function (fromModal, typeOfModal) {
            var self = this;
			self.slimLeasing = financialModel.leasingData.preventivo.slimLeasing;
            jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar(
              "scrollTo",
              0
            ); //posiziona la scollBar in top ad ogni cambio vista
            $("#footerInstant").css("z-index", "2");
            $(".financial-leasing__footer").css("z-index", "2");
            self.loading.nextStep = true;
            $timeout(function () {
              /**
               * Per prevenire che il BE invia un viewIndex come stringa e il nextStep incrementa l'indice in maniera errata
               * ho preferito in via precauzionale convertire il viewindex in intero
               */

              financialModel.viewIndex = parseInt(financialModel.viewIndex);
              var onlyLocal = false;
              /**
               * If view index is 0, call insert instance,
               */
              if (getWizardMap(financialModel.viewIndex) == "M1") {
                //onlyLocal = false;
                var input = "";
                if (!financialModel.financialVendor.riUserG) {
                  financialModel.financialVendor.riUserG = RiUserG.build({
                    ndg: financialModel.bank.ndg,
                    flagRicercaFiliale: true,
                  });
                }

                $financialApiService
                  .vendorGetDetail(financialModel.financialVendor.riUserG)
                  .then(function (vendorResponse) {
                    if (
                      vendorResponse.success != null &&
                      !vendorResponse.success
                    ) {
                      $location.path("/");
                      self.loading.nextStep = false;
                      $rootScope.disableDoubleClick = false;
                    } else if (vendorResponse) {
                      populateFinancialVendor(vendorResponse);

                      console.log("FINANCIAL MODEL ", financialModel);

                      if (
                        financialModel.idWfInstance == null ||
                        typeof financialModel.idWfInstance == undefined ||
                        financialModel.idWfInstance == 0
                      ) {
                        $workflowService
                          .insertInstance(type)
                          .then(function (newModel) {
                            newModel.financialVendor =
                              financialModel.financialVendor;
                            $workflowService
                              .nextStep(newModel, type, onlyLocal, newModel.taskFiliale)
                              .then(function (newFinancialModel) {
                                self.progressBar =
                                  newFinancialModel.frontEndOptions.progressBar;
                                self.enabled.enabledBack = !newFinancialModel
                                  .frontEndOptions.disabledBack;
                                self.enabled.enabledSave = !newFinancialModel
                                  .frontEndOptions.disabledSave;
                                self.actionBar =
                                  newFinancialModel.frontEndOptions.actionBar;
                                financialModel = Object.assign(
                                  FinancialModel.build({}),
                                  newFinancialModel
                                );
                                self.loading.nextStep = false;
                                $rootScope.disableDoubleClick = false;
                              })
                              .catch(function (error) {
                                console.log(error);
                                self.loading.nextStep = false;
                                $rootScope.disableDoubleClick = false;
                              });
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                            $rootScope.disableDoubleClick = false;
                          });
                      } else {
                        onlyLocal = true;
                        $workflowService
                          .nextStep(financialModel, type, onlyLocal, financialModel.taskFiliale)
                          .then(function (newFinancialModel) {
                            self.progressBar =
                              newFinancialModel.frontEndOptions.progressBar;
                            self.enabled.enabledBack = !newFinancialModel
                              .frontEndOptions.disabledBack;
                            self.enabled.enabledSave = !newFinancialModel
                              .frontEndOptions.disabledSave;
                            self.actionBar =
                              newFinancialModel.frontEndOptions.actionBar;
                            financialModel = newFinancialModel;
                            self.loading.nextStep = false;
                            $rootScope.disableDoubleClick = false;
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                            $rootScope.disableDoubleClick = false;
                          });
                      }
                    } else {
                      self.loading.nextStep = false;
                      $rootScope.disableDoubleClick = false;
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    self.loading.nextStep = false;
                    $rootScope.disableDoubleClick = false;
                  });
              } else if (getWizardMap(financialModel.viewIndex) == "M2") {
                if (fromModal) {
                  if (!!financialModel.financialCustomer.metadata.riUserG.ndg) {
                    $simulationService
                      .checkSaeRaeAteco(
                        financialModel.financialCustomer.metadata.riUserG.sae,
                        financialModel.financialCustomer.metadata.riUserG.rae,
                        financialModel.financialCustomer.metadata.riUserG.ateco,
                        financialModel.financialCustomer.metadata.riUserG.formaGiuridica,
                        financialModel.financialCustomer.metadata.riUserG.cf,
                        financialModel.financialCustomer.metadata.riUserG.piva
                      )
                      .then(function (response) {
                        if (response.success) {
                          if (financialModel.idWfInstance == null || typeof financialModel.idWfInstance == undefined || financialModel.idWfInstance == 0) {
                            $workflowService
                              .insertInstance(type)
                              .then(function (newModel) {
                                newModel.financialVendor =
                                  financialModel.financialVendor;
                                newModel.financialCustomer =
                                  financialModel.financialCustomer;
                                newModel.viewIndex = financialModel.viewIndex;
                                $workflowService
                                  .nextStep(newModel, type, onlyLocal, newModel.taskFiliale)
                                  .then(function (newFinancialModel) {
                                    // inizio
                                    if (!newFinancialModel.leasingData.id && getWizardMap(newFinancialModel.viewIndex) == "M5") {
                                      $financialApiService
                                        .getInsertAppPracticeDigital(newFinancialModel)
                                        .then(function (appPracticeResponse) {
                                          if (appPracticeResponse) {
                                            newFinancialModel.leasingData.id =
                                              appPracticeResponse.id;
                                            self.progressBar =
                                              newFinancialModel.frontEndOptions.progressBar;
                                            self.enabled.enabledBack = !newFinancialModel
                                              .frontEndOptions.disabledBack;
                                            self.enabled.enabledSave = !newFinancialModel
                                              .frontEndOptions.disabledSave;
                                            self.actionBar =
                                              newFinancialModel.frontEndOptions.actionBar;
                                            console.log(
                                              "new model returned!",
                                              newFinancialModel
                                            );
                                            financialModel = newFinancialModel;
                                            self.loading.nextStep = false;
                                            $rootScope.disableDoubleClick = false;
                                          }
                                        })
                                        .catch(function (error) {
                                          console.log("ERROR:", error);
                                          self.loading.nextStep = false;
                                          $rootScope.disableDoubleClick = false;
                                        });
                                    } else {
                                      self.progressBar =
                                        newFinancialModel.frontEndOptions.progressBar;
                                      self.enabled.enabledBack = !newFinancialModel
                                        .frontEndOptions.disabledBack;
                                      self.enabled.enabledSave = !newFinancialModel
                                        .frontEndOptions.disabledSave;
                                      self.actionBar =
                                        newFinancialModel.frontEndOptions.actionBar;
                                      console.log(
                                        "new model returned!",
                                        newFinancialModel
                                      );
                                      financialModel = newFinancialModel;
                                      self.loading.nextStep = false;
                                      $rootScope.disableDoubleClick = false;

                                    }
                                    // fine
                                  })
                                  .catch(function (error) {
                                    console.log(error);
                                    self.loading.nextStep = false;
                                    $rootScope.disableDoubleClick = false;
                                  });
                              })
                              .catch(function (error) {
                                console.log(error);
                                self.loading.nextStep = false;
                                $rootScope.disableDoubleClick = false;
                              });
                          } else {
                            onlyLocal = true;
                            $workflowService
                              .nextStep(financialModel, type, onlyLocal, financialModel.taskFiliale)
                              .then(function (newFinancialModel) {
                                // inizio
                                if (!newFinancialModel.leasingData.id && getWizardMap(newFinancialModel.viewIndex) == "M5") {
                                  $financialApiService
                                    .getInsertAppPracticeDigital(newFinancialModel)
                                    .then(function (appPracticeResponse) {
                                      if (appPracticeResponse) {
                                        newFinancialModel.leasingData.id =
                                          appPracticeResponse.id;
                                        self.progressBar =
                                          newFinancialModel.frontEndOptions.progressBar;
                                        self.enabled.enabledBack = !newFinancialModel
                                          .frontEndOptions.disabledBack;
                                        self.enabled.enabledSave = !newFinancialModel
                                          .frontEndOptions.disabledSave;
                                        self.actionBar =
                                          newFinancialModel.frontEndOptions.actionBar;
                                        console.log(
                                          "new model returned!",
                                          newFinancialModel
                                        );
                                        financialModel = newFinancialModel;
                                        self.loading.nextStep = false;
                                        $rootScope.disableDoubleClick = false;
                                      }
                                    })
                                    .catch(function (error) {
                                      console.log("ERROR:", error);
                                      self.loading.nextStep = false;
                                      $rootScope.disableDoubleClick = false;
                                    });
                                } else {
                                  self.progressBar =
                                    newFinancialModel.frontEndOptions.progressBar;
                                  self.enabled.enabledBack = !newFinancialModel
                                    .frontEndOptions.disabledBack;
                                  self.enabled.enabledSave = !newFinancialModel
                                    .frontEndOptions.disabledSave;
                                  self.actionBar =
                                    newFinancialModel.frontEndOptions.actionBar;
                                  console.log(
                                    "new model returned!",
                                    newFinancialModel
                                  );
                                  financialModel = newFinancialModel;
                                  self.loading.nextStep = false;
                                  $rootScope.disableDoubleClick = false;

                                }
                                // fine
                              })
                              .catch(function (error) {
                                console.log(error);
                                self.loading.nextStep = false;
                                $rootScope.disableDoubleClick = false;
                              });
                          }

                        } else {
                          $modalService.openModal("checkSaeRaeAtecoModal");
                          self.loading.nextStep = false;
                        }
                      })
                      .catch(function (error) {
                        console.log("ERROR:", error);
                        self.loading.nextStep = false;
                      });

                  } else {
                    if (financialModel.idWfInstance == null || typeof financialModel.idWfInstance == undefined || financialModel.idWfInstance == 0) {
                      $workflowService
                        .insertInstance(type)
                        .then(function (newModel) {
                          newModel.financialVendor =
                            financialModel.financialVendor;
                          newModel.financialCustomer =
                            financialModel.financialCustomer;
                          newModel.viewIndex = financialModel.viewIndex;
                          $workflowService
                            .nextStep(newModel, type, onlyLocal, newModel.taskFiliale)
                            .then(function (newFinancialModel) {
                              // inizio
                              if (!newFinancialModel.leasingData.id && getWizardMap(newFinancialModel.viewIndex) == "M5") {
                                $financialApiService
                                  .getInsertAppPracticeDigital(newFinancialModel)
                                  .then(function (appPracticeResponse) {
                                    if (appPracticeResponse) {
                                      newFinancialModel.leasingData.id =
                                        appPracticeResponse.id;
                                      self.progressBar =
                                        newFinancialModel.frontEndOptions.progressBar;
                                      self.enabled.enabledBack = !newFinancialModel
                                        .frontEndOptions.disabledBack;
                                      self.enabled.enabledSave = !newFinancialModel
                                        .frontEndOptions.disabledSave;
                                      self.actionBar =
                                        newFinancialModel.frontEndOptions.actionBar;
                                      console.log(
                                        "new model returned!",
                                        newFinancialModel
                                      );
                                      financialModel = newFinancialModel;
                                      self.loading.nextStep = false;
                                      $rootScope.disableDoubleClick = false;
                                    }
                                  })
                                  .catch(function (error) {
                                    console.log("ERROR:", error);
                                    self.loading.nextStep = false;
                                    $rootScope.disableDoubleClick = false;
                                  });
                              } else {
                                self.progressBar =
                                  newFinancialModel.frontEndOptions.progressBar;
                                self.enabled.enabledBack = !newFinancialModel
                                  .frontEndOptions.disabledBack;
                                self.enabled.enabledSave = !newFinancialModel
                                  .frontEndOptions.disabledSave;
                                self.actionBar =
                                  newFinancialModel.frontEndOptions.actionBar;
                                console.log(
                                  "new model returned!",
                                  newFinancialModel
                                );
                                financialModel = newFinancialModel;
                                self.loading.nextStep = false;
                                $rootScope.disableDoubleClick = false;

                              }
                              // fine
                            })
                            .catch(function (error) {
                              console.log(error);
                              self.loading.nextStep = false;
                              $rootScope.disableDoubleClick = false;
                            });
                        })
                        .catch(function (error) {
                          console.log(error);
                          self.loading.nextStep = false;
                          $rootScope.disableDoubleClick = false;
                        });
                    } else {
                      onlyLocal = true;
                      $workflowService
                        .nextStep(financialModel, type, onlyLocal, financialModel.taskFiliale)
                        .then(function (newFinancialModel) {
                          // inizio
                          if (!newFinancialModel.leasingData.id && getWizardMap(newFinancialModel.viewIndex) == "M5") {
                            $financialApiService
                              .getInsertAppPracticeDigital(newFinancialModel)
                              .then(function (appPracticeResponse) {
                                if (appPracticeResponse) {
                                  newFinancialModel.leasingData.id =
                                    appPracticeResponse.id;
                                  self.progressBar =
                                    newFinancialModel.frontEndOptions.progressBar;
                                  self.enabled.enabledBack = !newFinancialModel
                                    .frontEndOptions.disabledBack;
                                  self.enabled.enabledSave = !newFinancialModel
                                    .frontEndOptions.disabledSave;
                                  self.actionBar =
                                    newFinancialModel.frontEndOptions.actionBar;
                                  console.log(
                                    "new model returned!",
                                    newFinancialModel
                                  );
                                  financialModel = newFinancialModel;
                                  self.loading.nextStep = false;
                                  $rootScope.disableDoubleClick = false;
                                }
                              })
                              .catch(function (error) {
                                console.log("ERROR:", error);
                                self.loading.nextStep = false;
                                $rootScope.disableDoubleClick = false;
                              });
                          } else {
                            self.progressBar =
                              newFinancialModel.frontEndOptions.progressBar;
                            self.enabled.enabledBack = !newFinancialModel
                              .frontEndOptions.disabledBack;
                            self.enabled.enabledSave = !newFinancialModel
                              .frontEndOptions.disabledSave;
                            self.actionBar =
                              newFinancialModel.frontEndOptions.actionBar;
                            console.log(
                              "new model returned!",
                              newFinancialModel
                            );
                            financialModel = newFinancialModel;
                            self.loading.nextStep = false;
                            $rootScope.disableDoubleClick = false;

                          }
                          // fine
                        })
                        .catch(function (error) {
                          console.log(error);
                          self.loading.nextStep = false;
                          $rootScope.disableDoubleClick = false;
                        });
                    }
                  }

                } else {
                  $financialApiService
                    .getSearchRiUserG(financialModel.financialCustomer)
                    .then(function (listAppCustomer) {
                      if (listAppCustomer && listAppCustomer.appCustomerUser && listAppCustomer.appCustomerUser.warningAnagrafica && listAppCustomer.appCustomerUser.warningAnagrafica.showPopup) {
                        financialModel.financialCustomer = listAppCustomer.appCustomerUser;
                        Object.assign(financialModel, {
                          warningAnagrafica: listAppCustomer.appCustomerUser.warningAnagrafica
                        })
                        $modalService.openModal("warningAnagrafica-modal");
                        self.loading.nextStep = false;
                        $rootScope.disableDoubleClick = false;
                      } else if (listAppCustomer.success) {
                        financialModel.financialCustomer = listAppCustomer.appCustomerUser;
                        if (!!financialModel.financialCustomer.metadata.riUserG.ndg) {
                          $simulationService
                            .checkSaeRaeAteco(
                              financialModel.financialCustomer.metadata.riUserG.sae,
                              financialModel.financialCustomer.metadata.riUserG.rae,
                              financialModel.financialCustomer.metadata.riUserG.ateco,
                              financialModel.financialCustomer.metadata.riUserG.formaGiuridica,
                              financialModel.financialCustomer.metadata.riUserG.cf,
                              financialModel.financialCustomer.metadata.riUserG.piva
                            )
                            .then(function (response) {
                              if (response.success) {
                                if (financialModel.idWfInstance == null || typeof financialModel.idWfInstance == undefined || financialModel.idWfInstance == 0) {
                                  $workflowService
                                    .insertInstance(type)
                                    .then(function (newModel) {
                                      newModel.financialVendor =
                                        financialModel.financialVendor;
                                      newModel.financialCustomer =
                                        financialModel.financialCustomer;
                                      newModel.viewIndex = financialModel.viewIndex;
                                      $workflowService
                                        .nextStep(newModel, type, onlyLocal, newModel.taskFiliale)
                                        .then(function (newFinancialModel) {
                                          // inizio
                                          if (!newFinancialModel.leasingData.id && getWizardMap(newFinancialModel.viewIndex) == "M5") {
                                            $financialApiService
                                              .getInsertAppPracticeDigital(newFinancialModel)
                                              .then(function (appPracticeResponse) {
                                                if (appPracticeResponse) {
                                                  newFinancialModel.leasingData.id =
                                                    appPracticeResponse.id;
                                                  self.progressBar =
                                                    newFinancialModel.frontEndOptions.progressBar;
                                                  self.enabled.enabledBack = !newFinancialModel
                                                    .frontEndOptions.disabledBack;
                                                  self.enabled.enabledSave = !newFinancialModel
                                                    .frontEndOptions.disabledSave;
                                                  self.actionBar =
                                                    newFinancialModel.frontEndOptions.actionBar;
                                                  console.log(
                                                    "new model returned!",
                                                    newFinancialModel
                                                  );
                                                  financialModel = newFinancialModel;
                                                  self.loading.nextStep = false;
                                                  $rootScope.disableDoubleClick = false;
                                                }
                                              })
                                              .catch(function (error) {
                                                console.log("ERROR:", error);
                                                self.loading.nextStep = false;
                                                $rootScope.disableDoubleClick = false;
                                              });
                                          } else {
                                            self.progressBar =
                                              newFinancialModel.frontEndOptions.progressBar;
                                            self.enabled.enabledBack = !newFinancialModel
                                              .frontEndOptions.disabledBack;
                                            self.enabled.enabledSave = !newFinancialModel
                                              .frontEndOptions.disabledSave;
                                            self.actionBar =
                                              newFinancialModel.frontEndOptions.actionBar;
                                            console.log(
                                              "new model returned!",
                                              newFinancialModel
                                            );
                                            financialModel = newFinancialModel;
                                            self.loading.nextStep = false;
                                            $rootScope.disableDoubleClick = false;

                                          }
                                          // fine
                                        })
                                        .catch(function (error) {
                                          console.log(error);
                                          self.loading.nextStep = false;
                                          $rootScope.disableDoubleClick = false;
                                        });
                                    })
                                    .catch(function (error) {
                                      console.log(error);
                                      self.loading.nextStep = false;
                                      $rootScope.disableDoubleClick = false;
                                    });
                                } else {
                                  onlyLocal = true;
                                  $workflowService
                                    .nextStep(financialModel, type, onlyLocal, financialModel.taskFiliale)
                                    .then(function (newFinancialModel) {
                                      // inizio
                                      if (!newFinancialModel.leasingData.id && getWizardMap(newFinancialModel.viewIndex) == "M5") {
                                        $financialApiService
                                          .getInsertAppPracticeDigital(newFinancialModel)
                                          .then(function (appPracticeResponse) {
                                            if (appPracticeResponse) {
                                              newFinancialModel.leasingData.id =
                                                appPracticeResponse.id;
                                              self.progressBar =
                                                newFinancialModel.frontEndOptions.progressBar;
                                              self.enabled.enabledBack = !newFinancialModel
                                                .frontEndOptions.disabledBack;
                                              self.enabled.enabledSave = !newFinancialModel
                                                .frontEndOptions.disabledSave;
                                              self.actionBar =
                                                newFinancialModel.frontEndOptions.actionBar;
                                              console.log(
                                                "new model returned!",
                                                newFinancialModel
                                              );
                                              financialModel = newFinancialModel;
                                              self.loading.nextStep = false;
                                              $rootScope.disableDoubleClick = false;
                                            }
                                          })
                                          .catch(function (error) {
                                            console.log("ERROR:", error);
                                            self.loading.nextStep = false;
                                            $rootScope.disableDoubleClick = false;
                                          });
                                      } else {
                                        self.progressBar =
                                          newFinancialModel.frontEndOptions.progressBar;
                                        self.enabled.enabledBack = !newFinancialModel
                                          .frontEndOptions.disabledBack;
                                        self.enabled.enabledSave = !newFinancialModel
                                          .frontEndOptions.disabledSave;
                                        self.actionBar =
                                          newFinancialModel.frontEndOptions.actionBar;
                                        console.log(
                                          "new model returned!",
                                          newFinancialModel
                                        );
                                        financialModel = newFinancialModel;
                                        self.loading.nextStep = false;
                                        $rootScope.disableDoubleClick = false;

                                      }
                                      // fine
                                    })
                                    .catch(function (error) {
                                      console.log(error);
                                      self.loading.nextStep = false;
                                      $rootScope.disableDoubleClick = false;
                                    });
                                }

                              } else {
                                $modalService.openModal("checkSaeRaeAtecoModal");
                                self.loading.nextStep = false;
                              }
                            })
                            .catch(function (error) {
                              console.log("ERROR:", error);
                              self.loading.nextStep = false;
                            });
                        } else {
                          if (financialModel.idWfInstance == null || typeof financialModel.idWfInstance == undefined || financialModel.idWfInstance == 0) {
                            $workflowService
                              .insertInstance(type)
                              .then(function (newModel) {
                                newModel.financialVendor =
                                  financialModel.financialVendor;
                                newModel.financialCustomer =
                                  financialModel.financialCustomer;
                                newModel.viewIndex = financialModel.viewIndex;
                                $workflowService
                                  .nextStep(newModel, type, onlyLocal, newModel.taskFiliale)
                                  .then(function (newFinancialModel) {
                                    // inizio
                                    if (!newFinancialModel.leasingData.id && getWizardMap(newFinancialModel.viewIndex) == "M5") {
                                      $financialApiService
                                        .getInsertAppPracticeDigital(newFinancialModel)
                                        .then(function (appPracticeResponse) {
                                          if (appPracticeResponse) {
                                            newFinancialModel.leasingData.id =
                                              appPracticeResponse.id;
                                            self.progressBar =
                                              newFinancialModel.frontEndOptions.progressBar;
                                            self.enabled.enabledBack = !newFinancialModel
                                              .frontEndOptions.disabledBack;
                                            self.enabled.enabledSave = !newFinancialModel
                                              .frontEndOptions.disabledSave;
                                            self.actionBar =
                                              newFinancialModel.frontEndOptions.actionBar;
                                            console.log(
                                              "new model returned!",
                                              newFinancialModel
                                            );
                                            financialModel = newFinancialModel;
                                            self.loading.nextStep = false;
                                            $rootScope.disableDoubleClick = false;
                                          }
                                        })
                                        .catch(function (error) {
                                          console.log("ERROR:", error);
                                          self.loading.nextStep = false;
                                          $rootScope.disableDoubleClick = false;
                                        });
                                    } else {
                                      self.progressBar =
                                        newFinancialModel.frontEndOptions.progressBar;
                                      self.enabled.enabledBack = !newFinancialModel
                                        .frontEndOptions.disabledBack;
                                      self.enabled.enabledSave = !newFinancialModel
                                        .frontEndOptions.disabledSave;
                                      self.actionBar =
                                        newFinancialModel.frontEndOptions.actionBar;
                                      console.log(
                                        "new model returned!",
                                        newFinancialModel
                                      );
                                      financialModel = newFinancialModel;
                                      self.loading.nextStep = false;
                                      $rootScope.disableDoubleClick = false;

                                    }
                                    // fine
                                  })
                                  .catch(function (error) {
                                    console.log(error);
                                    self.loading.nextStep = false;
                                    $rootScope.disableDoubleClick = false;
                                  });
                              })
                              .catch(function (error) {
                                console.log(error);
                                self.loading.nextStep = false;
                                $rootScope.disableDoubleClick = false;
                              });
                          } else {
                            onlyLocal = true;
                            $workflowService
                              .nextStep(financialModel, type, onlyLocal, financialModel.taskFiliale)
                              .then(function (newFinancialModel) {
                                // inizio
                                if (!newFinancialModel.leasingData.id && getWizardMap(newFinancialModel.viewIndex) == "M5") {
                                  $financialApiService
                                    .getInsertAppPracticeDigital(newFinancialModel)
                                    .then(function (appPracticeResponse) {
                                      if (appPracticeResponse) {
                                        newFinancialModel.leasingData.id =
                                          appPracticeResponse.id;
                                        self.progressBar =
                                          newFinancialModel.frontEndOptions.progressBar;
                                        self.enabled.enabledBack = !newFinancialModel
                                          .frontEndOptions.disabledBack;
                                        self.enabled.enabledSave = !newFinancialModel
                                          .frontEndOptions.disabledSave;
                                        self.actionBar =
                                          newFinancialModel.frontEndOptions.actionBar;
                                        console.log(
                                          "new model returned!",
                                          newFinancialModel
                                        );
                                        financialModel = newFinancialModel;
                                        self.loading.nextStep = false;
                                        $rootScope.disableDoubleClick = false;
                                      }
                                    })
                                    .catch(function (error) {
                                      console.log("ERROR:", error);
                                      self.loading.nextStep = false;
                                      $rootScope.disableDoubleClick = false;
                                    });
                                } else {
                                  self.progressBar =
                                    newFinancialModel.frontEndOptions.progressBar;
                                  self.enabled.enabledBack = !newFinancialModel
                                    .frontEndOptions.disabledBack;
                                  self.enabled.enabledSave = !newFinancialModel
                                    .frontEndOptions.disabledSave;
                                  self.actionBar =
                                    newFinancialModel.frontEndOptions.actionBar;
                                  console.log(
                                    "new model returned!",
                                    newFinancialModel
                                  );
                                  financialModel = newFinancialModel;
                                  self.loading.nextStep = false;
                                  $rootScope.disableDoubleClick = false;

                                }
                                // fine
                              })
                              .catch(function (error) {
                                console.log(error);
                                self.loading.nextStep = false;
                                $rootScope.disableDoubleClick = false;
                              });
                          }

                        }

                      } else {
                        self.loading.nextStep = false;
                        $rootScope.disableDoubleClick = false;
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                      $rootScope.disableDoubleClick = false;
                    });
                }
              } else if (getWizardMap(financialModel.viewIndex) == "M4") {
                if (financialModel.financialCustomer.metadata.riUserG.formaGiuridica === 'PEF') {
                  if (financialModel.financialCustomer.metadata.riUserF.listaPf.length && financialModel.financialCustomer.metadata.riUserF.listaPf[0].cognome && financialModel.financialCustomer.metadata.riUserF.listaPf[0].nome) {
                    financialModel.financialCustomer.metadata.riUserG.ragioneSociale = financialModel.financialCustomer.metadata.riUserF.listaPf[0].cognome.concat(" ").concat(financialModel.financialCustomer.metadata.riUserF.listaPf[0].nome)
                  }
                }
                if ($giuridicVersion.checkIfInd(financialModel.financialCustomer.metadata.riUserG.formaGiuridica)
                  && !!!financialModel.financialCustomer.metadata.riUserG.ndg && financialModel.financialCustomer.metadata.riUserF.listaPf[0] && financialModel.financialCustomer.metadata.riUserF.listaPf[0].residenza.comune == null) {
                  financialModel.financialCustomer.metadata.riUserF.listaPf[0].residenza = Residenza.build(financialModel.financialCustomer.metadata.riUserG.sedeLegale)
                }
                onlyLocal = true;
                $simulationService
                  .checkSaeRaeAteco(
                    financialModel.financialCustomer.metadata.riUserG.sae,
                    financialModel.financialCustomer.metadata.riUserG.rae,
                    financialModel.financialCustomer.metadata.riUserG.ateco,
                    financialModel.financialCustomer.metadata.riUserG.formaGiuridica,
                    financialModel.financialCustomer.metadata.riUserG.cf,
                    financialModel.financialCustomer.metadata.riUserG.piva
                  )
                  .then(function (response) {
                    if (response.success) {
                      $userService
                        .checkAggiornaAnagrafica(
                          financialModel.financialCustomer.metadata.riUserG
                        )
                        .then(function (response) {
                          if (response.valid) {
                            if (response.ndg) {
                              financialModel.financialCustomer.metadata.riUserG.ndg = response.ndg;
                            }
                            if (response.piva) {
                              financialModel.financialCustomer.metadata.riUserG.piva = response.piva;
                            }
                            if (response.ateco) {
                              financialModel.financialCustomer.metadata.riUserG.ateco = response.ateco;
                            }
                            if (response.sae) {
                              financialModel.financialCustomer.metadata.riUserG.sae = response.sae;
                            }
                            if (response.rae) {
                              financialModel.financialCustomer.metadata.riUserG.rae = response.rae;
                            }
                            if (response.cciaa) {
                              financialModel.financialCustomer.metadata.riUserG.cciaa = response.cciaa;
                            }
                            if (response.cciaaPv) {
                              financialModel.financialCustomer.metadata.riUserG.cciaaPv = response.cciaaPv;
                            }

                            // Se non ho numero pratica, chiamo il rest che mi restituisce il n° pratica (Leasing.id)
                            if (!financialModel.leasingData.id) {
                              $financialApiService
                                .getInsertAppPracticeDigital(financialModel)
                                .then(function (appPracticeResponse) {
                                  if (appPracticeResponse) {
                                    financialModel.leasingData.id =
                                      appPracticeResponse.id;
                                    console.log(
                                      "instanModel added on APP_PRACTICE_DIGITAL: ",
                                      appPracticeResponse
                                    );
                                    $simulationService.checkPracticeVendorCustomer(financialModel)
                                      .then(function (response) {
                                        if (response.success) {
                                          $workflowService
                                            .nextStep(
                                              FinancialModel.build(financialModel),
                                              type,
                                              onlyLocal,
                                              financialModel.taskFiliale
                                            )
                                            .then(function (newFinancialModel) {
                                              self.progressBar =
                                                newFinancialModel.frontEndOptions.progressBar;
                                              self.enabled.enabledBack = !newFinancialModel
                                                .frontEndOptions.disabledBack;
                                              self.enabled.enabledSave = !newFinancialModel
                                                .frontEndOptions.disabledSave;
                                              self.actionBar =
                                                newFinancialModel.frontEndOptions.actionBar;
                                              console.log(
                                                "new model returned!",
                                                newFinancialModel
                                              );
                                              financialModel = newFinancialModel;
                                              self.loading.nextStep = false;
                                            })
                                            .catch(function (error) {
                                              console.log(error);
                                              self.loading.nextStep = false;
                                            });
                                        } else {
                                          self.loading.nextStep = false;
                                        }
                                      })
                                      .catch(function (error) {
                                        console.log(error);
                                        self.loading.nextStep = false;
                                      })
                                  }
                                })
                                .catch(function (error) {
                                  console.log("ERROR:", error);
                                  self.loading.nextStep = false;
                                });
                              // Se ho un numero pratica, non chiamo il rest così non duplico il Leasing.id nel DB
                            } else {
                              $simulationService.checkPracticeVendorCustomer(financialModel)
                                .then(function (response) {
                                  if (response.success) {
                                    $workflowService
                                      .nextStep(
                                        FinancialModel.build(financialModel),
                                        type,
                                        onlyLocal,
                                        financialModel.taskFiliale
                                      )
                                      .then(function (newFinancialModel) {
                                        self.progressBar =
                                          newFinancialModel.frontEndOptions.progressBar;
                                        self.enabled.enabledBack = !newFinancialModel
                                          .frontEndOptions.disabledBack;
                                        self.enabled.enabledSave = !newFinancialModel
                                          .frontEndOptions.disabledSave;
                                        self.actionBar =
                                          newFinancialModel.frontEndOptions.actionBar;
                                        console.log(
                                          "new model returned!",
                                          newFinancialModel
                                        );
                                        financialModel = newFinancialModel;
                                        self.loading.nextStep = false;
                                      })
                                      .catch(function (error) {
                                        console.log(error);
                                        self.loading.nextStep = false;
                                      });
                                  } else {
                                    self.loading.nextStep = false;
                                  }
                                })
                                .catch(function (error) {
                                  console.log(error);
                                  self.loading.nextStep = false;
                                })
                            }
                          } else {
                            financialModel.checkAggiornaAnagrafica = response;
                            $modalService.openModal("refreshCervedModal");
                            self.loading.nextStep = false;
                          }
                        })
                        .catch(function (error) {
                          console.log("ERROR: ", error);
                          self.loading.nextStep = false;
                        });
                    } else {
                      $modalService.openModal("checkSaeRaeAtecoModal");
                      self.loading.nextStep = false;
                    }
                  })
                  .catch(function (error) {
                    console.log("ERROR:", error);
                    self.loading.nextStep = false;
                  });
              } else if (getWizardMap(financialModel.viewIndex) == "M5") {
                if (fromModal && typeOfModal == "checkDeroga") {
                  onlyLocal = true;
                  self.loading.nextStep = true;
                  $modalService.closeModal("checkDeroga-modal");
                  $workflowService
                    .nextStep(
                      FinancialModel.build(financialModel),
                      type,
                      onlyLocal,
                      financialModel.taskFiliale
                    )
                    .then(function (newFinancialModel) {
                      self.progressBar =
                        newFinancialModel.frontEndOptions.progressBar;
                      self.enabled.enabledBack = !newFinancialModel
                        .frontEndOptions.disabledBack;
                      self.enabled.enabledSave = !newFinancialModel
                        .frontEndOptions.disabledSave;
                      self.actionBar =
                        newFinancialModel.frontEndOptions.actionBar;
                      console.log("new model returned!", newFinancialModel);
                      financialModel = newFinancialModel;
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                } else {
                  if (
                    financialModel.leasingData.preventivo.prodotto.isTargato &&
                    financialModel.leasingData.preventivo.prodotto.id !=
                    "AVI" &&
                    financialModel.leasingData.preventivo.prodotto
                      .quotaEsente == 0 &&
                    !fromModal
                  ) {
                    $modalService.openModal("quotaEsente-modal");
                    self.loading.nextStep = false;
                  } else {
                    $modalService.closeModal("quotaEsente-modal");
                    self.loading.nextStep = true;
                    // $financialApiService
                    //   .checkSovrapposizioni(
                    //     FinancialModel.build(financialModel)
                    //   )
                    //   .then(function (response) {
                    // financialModel.leasingData.preventivo.dettaglioDeroga = DettaglioDeroga.build(
                    //   response
                    // );
                    // var stessaFilialeIsPresent =
                    //   response.preventiviSovrapposizione &&
                    //   response.preventiviSovrapposizione.some(function (
                    //     element
                    //   ) {
                    //     return element.stessaFiliera == true;
                    //   });
                    // var preAuthorizedIsPresent = response.dettaglioDerogaNSIL &&
                    //   response.dettaglioDerogaNSIL.some(function (element) {
                    //     return element.preAuthorized == true;
                    //   })
                    // Object.assign(response, {
                    //   stessaFiliera: stessaFilialeIsPresent,
                    //   preAuthorizedIsPresent: preAuthorizedIsPresent
                    // });
                    // setChecDeroga(response);
                    // console.log(getChecDeroga());
                    // if (
                    //   !response.derogaSovrapposizione &&
                    //   !response.derogaFinanziaria
                    // ) {
                    var onlyLocal = true;
                    $workflowService
                      .nextStep(
                        FinancialModel.build(financialModel),
                        type,
                        onlyLocal,
                        financialModel.taskFiliale
                      )
                      .then(function (newFinancialModel) {
                        self.progressBar =
                          newFinancialModel.frontEndOptions.progressBar;
                        self.enabled.enabledBack = !newFinancialModel
                          .frontEndOptions.disabledBack;
                        self.enabled.enabledSave = !newFinancialModel
                          .frontEndOptions.disabledSave;
                        self.actionBar =
                          newFinancialModel.frontEndOptions.actionBar;
                        console.log(
                          "new model returned!",
                          newFinancialModel
                        );
                        financialModel = newFinancialModel;
                        self.loading.nextStep = false;
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.loading.nextStep = false;
                      });
                    // } else if (
                    //   response.derogaSovrapposizione ||
                    //   response.derogaFinanziaria
                    // ) {
                    //   $modalService.openModal("checkDeroga-modal");
                    //   self.loading.nextStep = false;
                    // }
                    // })
                    // .catch(function (error) {
                    //   console.log(error);
                    //   self.loading.nextStep = false;
                    // });
                  }
                }
              } else if (getWizardMap(financialModel.viewIndex) == "M6") {
                if (fromModal && typeOfModal == "checkDeroga") {
                  onlyLocal = false;
                  self.loading.nextStep = true;
                  $modalService.closeModal("checkDeroga-modal");
                  $workflowService
                    .checkConcurrence(getModel().idWfInstance)
                    .then(function (resp) {
                      if (resp.success) {
                        $financialApiService
                          .uploadPreventiveDigital(
                            FinancialModel.build(financialModel),
                            type,
                            onlyLocal
                          )
                          .then(function (response) {
                            if (getChecDeroga().derogaFinanziaria || getChecDeroga().derogaSovrapposizione) {
                              self.loading.nextStep = false;
                              $location.path("/");
                            } else if (response.success) {
                              onlyLocal = true;
                              financialModel = FinancialModel.build(
                                response.financialModel
                              );
                              financialModel.frontEndOptions =
                                response.frontEndOptions;
                              self.progressBar =
                                financialModel.frontEndOptions.progressBar;
                              self.enabled.enabledBack = !financialModel
                                .frontEndOptions.disabledBack;
                              self.enabled.enabledSave = !financialModel
                                .frontEndOptions.disabledSave;
                              self.actionBar =
                                financialModel.frontEndOptions.actionBar;
                            }
                            self.loading.nextStep = false;
                          })
                          .catch(function (err) {
                            console.log(err)
                            self.loading.nextStep = false;
                          });
                      } else {
                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function () {
                      self.loading.nextStep = false;
                    });
                } else if (fromModal && typeOfModal == "infoTassi") {
                  $modalService.closeModal("infoTassi-modal");
                  self.loading.nextStep = true;
                  financialModel.leasingData.preventivo.assicurazioni = financialModel.leasingData.preventivo.assicurazioni.filter(
                    function (element) {
                      return element != "";
                    }
                  );
                  $financialApiService
                    .checkDeroga(FinancialModel.build(financialModel))
                    .then(function (response) {
                      if (response.success) {
                        var stessaFilialeIsPresent =
                          response.preventiviSovrapposizione &&
                          response.preventiviSovrapposizione.some(function (
                            element
                          ) {
                            return element.stessaFiliera == true;
                          });
                        var preAuthorizedIsPresent = response.dettaglioDerogaNSIL &&
                          response.dettaglioDerogaNSIL.some(function (element) {
                            return element.preAuthorized == true;
                          })
                        Object.assign(response, {
                          stessaFiliera: stessaFilialeIsPresent,
                          preAuthorizedIsPresent: preAuthorizedIsPresent
                        });
                        Object.assign(response, {
                          mappa: getWizardMap(financialModel.viewIndex)
                        })
                        setChecDeroga(response);
                        financialModel.leasingData.preventivo.dettaglioDeroga = DettaglioDeroga.build(
                          response
                        );
                        if (response.showMngOptions) {
                          financialModel.leasingData.preventivo.dettaglioDeroga.tipoAzione = "tengoInCarico"
                        }
                        if (
                          !response.derogaSovrapposizione &&
                          !response.derogaFinanziaria
                        ) {
                          $financialApiService
                            .uploadPreventiveDigital(
                              FinancialModel.build(financialModel),
                              type,
                              onlyLocal
                            )
                            .then(function (response) {
                              if (response.success) {
                                onlyLocal = true;
                                self.loading.nextStep = true;
                                financialModel = FinancialModel.build(
                                  response.financialModel
                                );
                                financialModel.frontEndOptions =
                                  response.frontEndOptions;
                                self.progressBar =
                                  financialModel.frontEndOptions.progressBar;
                                self.enabled.enabledBack = !financialModel
                                  .frontEndOptions.disabledBack;
                                self.enabled.enabledSave = !financialModel
                                  .frontEndOptions.disabledSave;
                                self.actionBar =
                                  financialModel.frontEndOptions.actionBar;
                              }
                              self.loading.nextStep = false;
                            })
                            .catch(function () {
                              self.loading.nextStep = false;
                            });
                        } else {
                          $modalService.openModal("checkDeroga-modal");
                          self.loading.nextStep = false;
                        }
                      } else {
                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });

                } else {
                  financialModel.leasingData.preventivo.pianoFinanziario.speseFisse = true;
                  if (financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.indice.famigliaIndicizzazione == "IRS" &&
                    financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id != "FIX"
                  ) {

                    $modalService.openModal("infoTassi-modal");
                    self.loading.nextStep = false;

                  } else {

                    self.loading.nextStep = true;
                    financialModel.leasingData.preventivo.assicurazioni = financialModel.leasingData.preventivo.assicurazioni.filter(
                      function (element) {
                        return element != "";
                      }
                    );
                    $financialApiService
                      .checkDeroga(FinancialModel.build(financialModel))
                      .then(function (response) {
                        if (response.success) {
                          var stessaFilialeIsPresent =
                            response.preventiviSovrapposizione &&
                            response.preventiviSovrapposizione.some(function (
                              element
                            ) {
                              return element.stessaFiliera == true;
                            });
                          var preAuthorizedIsPresent = response.dettaglioDerogaNSIL &&
                            response.dettaglioDerogaNSIL.some(function (element) {
                              return element.preAuthorized == true;
                            })
                          Object.assign(response, {
                            stessaFiliera: stessaFilialeIsPresent,
                            preAuthorizedIsPresent: preAuthorizedIsPresent
                          });
                          Object.assign(response, {
                            mappa: getWizardMap(financialModel.viewIndex)
                          })
                          setChecDeroga(response);
                          console.log(getChecDeroga());
                          financialModel.leasingData.preventivo.dettaglioDeroga = DettaglioDeroga.build(
                            response
                          );
                          if (response.showMngOptions) {
                            financialModel.leasingData.preventivo.dettaglioDeroga.tipoAzione = "tengoInCarico"
                          }
                          if (
                            !response.derogaSovrapposizione &&
                            !response.derogaFinanziaria &&
                            !response.derogaRedditivitaOk
                          ) {
                            $financialApiService
                              .uploadPreventiveDigital(
                                FinancialModel.build(financialModel),
                                type,
                                onlyLocal
                              )
                              .then(function (response) {
                                if (response.success) {
                                  onlyLocal = true;
                                  self.loading.nextStep = true;
                                  financialModel = FinancialModel.build(
                                    response.financialModel
                                  );
                                  financialModel.frontEndOptions =
                                    response.frontEndOptions;
                                  self.progressBar =
                                    financialModel.frontEndOptions.progressBar;
                                  self.enabled.enabledBack = !financialModel
                                    .frontEndOptions.disabledBack;
                                  self.enabled.enabledSave = !financialModel
                                    .frontEndOptions.disabledSave;
                                  self.actionBar =
                                    financialModel.frontEndOptions.actionBar;
                                }
                                self.loading.nextStep = false;
                              })
                              .catch(function () {
                                self.loading.nextStep = false;
                              });
                          } else {
                            $modalService.openModal("checkDeroga-modal");
                            self.loading.nextStep = false;
                          }
                        } else {
                          self.loading.nextStep = false;
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.loading.nextStep = false;
                      });
                  }
                }
              } else if (getWizardMap(financialModel.viewIndex) == "M13b") {
                onlyLocal = false;
                var domande =
                  financialModel.financialCustomer.metadata.questionarioQva
                    .domande;

                if (fromModal) {
                  $modalService.closeModal("preventive-accept-modal");
                  if ($portalService.isAru()) {
                    setAcceptMode(true);
                    self.loading.nextStep = false;
                  } else {
                    onlyLocal = true;
                    $workflowService
                      .nextStep(
                        FinancialModel.build(financialModel),
                        type,
                        onlyLocal,
                        financialModel.taskFiliale
                      )
                      .then(function (newFinancialModel) {
                        self.progressBar =
                          newFinancialModel.frontEndOptions.progressBar;
                        self.enabled.enabledBack = !newFinancialModel
                          .frontEndOptions.disabledBack;
                        self.enabled.enabledSave = !newFinancialModel
                          .frontEndOptions.disabledSave;
                        self.actionBar =
                          newFinancialModel.frontEndOptions.actionBar;
                        console.log("new model returned!", newFinancialModel);
                        financialModel = newFinancialModel;
                        self.loading.nextStep = false;
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.loading.nextStep = false;
                      });
                  }
                } else {
                  var codQuestionario = financialModel.financialCustomer.metadata.questionarioQva.codQuestionario;
                  $userService
                    .sendQva(domande, financialModel.idWfInstance, codQuestionario)
                    .then(function (response) {
                      var onlyLocal = false;
                      financialModel.financialCustomer.metadata.questionarioQva = response;
                      setQvaInfo(response);
                      if (response.esito == "A") {
                        if ($portalService.isAru()) {
                          $modalService.openModal("preventive-accept-modal");
                          self.loading.nextStep = false;
                        } else {
                          onlyLocal = true;
                          $workflowService
                            .nextStep(
                              FinancialModel.build(financialModel),
                              type,
                              onlyLocal,
                              financialModel.taskFiliale
                            )
                            .then(function (newFinancialModel) {
                              self.progressBar =
                                newFinancialModel.frontEndOptions.progressBar;
                              self.enabled.enabledBack = !newFinancialModel
                                .frontEndOptions.disabledBack;
                              self.enabled.enabledSave = !newFinancialModel
                                .frontEndOptions.disabledSave;
                              self.actionBar =
                                newFinancialModel.frontEndOptions.actionBar;
                              console.log(
                                "new model returned!",
                                newFinancialModel
                              );
                              financialModel = newFinancialModel;
                              self.loading.nextStep = false;
                            })
                            .catch(function (error) {
                              console.log(error);
                              self.loading.nextStep = false;
                            });
                        }
                      } else if (response.esito == "NR") {
                        $modalService.openModal("qva-modal-1");
                        self.loading.nextStep = false;
                      } else {
                        $modalService.openModal("qva-modal");
                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                }
              } else if (getWizardMap(financialModel.viewIndex) == "MP1") {
                onlyLocal = true;
                $workflowService
                  .nextStep(
                    FinancialModel.build(financialModel),
                    type,
                    onlyLocal,
                    financialModel.taskFiliale
                  )
                  .then(function (newFinancialModel) {
                    self.progressBar =
                      newFinancialModel.frontEndOptions.progressBar;
                    self.enabled.enabledBack = !newFinancialModel
                      .frontEndOptions.disabledBack;
                    self.enabled.enabledSave = !newFinancialModel
                      .frontEndOptions.disabledSave;
                    self.actionBar =
                      newFinancialModel.frontEndOptions.actionBar;
                    console.log("new model returned!", newFinancialModel);
                    financialModel = newFinancialModel;
                    self.loading.nextStep = false;
                  })
                  .catch(function (error) {
                    console.log(error);
                    self.loading.nextStep = false;
                  });
              } else if (getWizardMap(financialModel.viewIndex) == "RP") {
                onlyLocal = false;

                var privacy = financialModel.financialCustomer.metadata.privacy;
                financialModel.financialCustomer.metadata.privacy.cf =
                  financialModel.financialCustomer.metadata.riUserG.cf;
                financialModel.financialCustomer.metadata.privacy.legalForm =
                  financialModel.financialCustomer.metadata.riUserG.formaGiuridica;

                if (!$portalService.isAru()) {
                  if (
                    !financialModel.financialCustomer.metadata.privacy.valid
                  ) {
                    $privacyService
                      .setPrivacyData(privacy)
                      .then(function (response) {
                        if (response.success) {
                          if (
                            !financialModel.leasingData.preventivo
                              .nuovoPrestoleasing &&
                            !financialModel.leasingData.preventivo.nuovoPrestoleasingDerogabile &&
                            !$portalService.isAru()
                          ) {
                            $modalService.openModal("preventive-accept-modal");
                            self.loading.nextStep = false;
                          } else {
                            var onlyLocal = true;
                            $workflowService
                              .nextStep(
                                FinancialModel.build(financialModel),
                                type,
                                onlyLocal,
                                financialModel.taskFiliale
                              )
                              .then(function (newFinancialModel) {
                                self.progressBar =
                                  newFinancialModel.frontEndOptions.progressBar;
                                self.enabled.enabledBack = !newFinancialModel
                                  .frontEndOptions.disabledBack;
                                self.enabled.enabledSave = !newFinancialModel
                                  .frontEndOptions.disabledSave;
                                self.actionBar =
                                  newFinancialModel.frontEndOptions.actionBar;
                                console.log(
                                  "new model returned!",
                                  newFinancialModel
                                );
                                financialModel = newFinancialModel;
                                self.loading.nextStep = false;
                              })
                              .catch(function (error) {
                                console.log(error);
                                self.loading.nextStep = false;
                              });
                          }
                        } else {
                          $rootScope.$broadcast("addAlert", {
                            text: "ERROR_GENERIC"
                          });
                          self.loading.nextStep = false;
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.loading.nextStep = false;
                      });
                  } else {
                    if (
                      !financialModel.leasingData.preventivo
                        .nuovoPrestoleasing &&
                      !$portalService.isAru() &&
                      !financialModel.leasingData.preventivo.nuovoPrestoleasingDerogabile &&
                      !financialModel.leasingData.preventivo.isTargato
                    ) {
                      $modalService.openModal("preventive-accept-modal");
                      self.loading.nextStep = false;
                    } else if (!financialModel.leasingData.preventivo
                      .nuovoPrestoleasing &&
                      !$portalService.isAru() &&
                      !financialModel.leasingData.preventivo.nuovoPrestoleasingDerogabile &&
                      financialModel.leasingData.preventivo.isTargato) {
                      $modalService.openModal("targatoAcceptanceModal");
                    } else {
                      var onlyLocal = true;
                      $workflowService
                        .nextStep(
                          FinancialModel.build(financialModel),
                          type,
                          onlyLocal,
                          financialModel.taskFiliale
                        )
                        .then(function (newFinancialModel) {
                          self.progressBar =
                            newFinancialModel.frontEndOptions.progressBar;
                          self.enabled.enabledBack = !newFinancialModel
                            .frontEndOptions.disabledBack;
                          self.enabled.enabledSave = !newFinancialModel
                            .frontEndOptions.disabledSave;
                          self.actionBar =
                            newFinancialModel.frontEndOptions.actionBar;
                          console.log("new model returned!", newFinancialModel);
                          financialModel = newFinancialModel;
                          self.loading.nextStep = false;
                        })
                        .catch(function (error) {
                          console.log(error);
                          self.loading.nextStep = false;
                        });
                    }
                  }
                } else {
                  if (
                    (financialModel.leasingData.isTariffaPlafond &&
                      $portalService.isAru()) ||
                    (financialModel.leasingData.preventivo.direttaConduttore &&
                      $portalService.isAru())
                  ) {
                    $modalService.openModal("preventive-accept-modal");
                    self.loading.nextStep = false;
                  } else {
                    onlyLocal = true;
                    $workflowService
                      .nextStep(
                        FinancialModel.build(financialModel),
                        type,
                        onlyLocal,
                        financialModel.taskFiliale
                      )
                      .then(function (newFinancialModel) {
                        self.progressBar =
                          newFinancialModel.frontEndOptions.progressBar;
                        self.enabled.enabledBack = !newFinancialModel
                          .frontEndOptions.disabledBack;
                        self.enabled.enabledSave = !newFinancialModel
                          .frontEndOptions.disabledSave;
                        self.actionBar =
                          newFinancialModel.frontEndOptions.actionBar;
                        console.log("new model returned!", newFinancialModel);
                        financialModel = newFinancialModel;
                        self.loading.nextStep = false;
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.loading.nextStep = false;
                      });
                  }
                }
              } else if (getWizardMap(financialModel.viewIndex) == "M11") {
                if (fromModal) {
                  $modalService.closeModal("checkRichiesta-modal");
                  self.loading.nextStep = true;
                  onlyLocal = true;
                  if ($portalService.isAru()) {
                    $financialApiService
                      .generateChecklistDocs(
                        FinancialModel.build(financialModel),
                        type
                      )
                      .then(function (response) {
                        if (response.success) {
                          $workflowService
                            .nextStep(
                              FinancialModel.build(financialModel),
                              type,
                              onlyLocal,
                              financialModel.taskFiliale
                            )
                            .then(function (newFinancialModel) {
                              self.progressBar =
                                newFinancialModel.frontEndOptions.progressBar;
                              self.enabled.enabledBack = !newFinancialModel
                                .frontEndOptions.disabledBack;
                              self.enabled.enabledSave = !newFinancialModel
                                .frontEndOptions.disabledSave;
                              self.actionBar =
                                newFinancialModel.frontEndOptions.actionBar;
                              console.log(
                                "new model returned!",
                                newFinancialModel
                              );
                              financialModel = newFinancialModel;
                              self.loading.nextStep = false;
                            })
                            .catch(function (error) {
                              console.log(error);
                              self.loading.nextStep = false;
                            });
                        } else {
                          self.loading.nextStep = false;
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.loading.nextStep = false;
                      });
                  } else {
                    $financialApiService
                      .checkOwnership(
                        FinancialModel.build(financialModel),
                        type,
                        onlyLocal,
                        financialModel.taskFiliale
                      )
                      .then(function (response) {
                        if (response.goHome) {
                          self.loading.nextStep = false;
                          $location.path("/");
                        } else {
                          $workflowService
                            .nextStep(
                              FinancialModel.build(financialModel),
                              type,
                              onlyLocal,
                              financialModel.taskFiliale
                            )
                            .then(function (newFinancialModel) {

                              self.progressBar =
                                newFinancialModel.frontEndOptions.progressBar;
                              self.enabled.enabledBack = !newFinancialModel
                                .frontEndOptions.disabledBack;
                              self.enabled.enabledSave = !newFinancialModel
                                .frontEndOptions.disabledSave;
                              self.actionBar =
                                newFinancialModel.frontEndOptions.actionBar;
                              console.log(
                                "new model returned!",
                                newFinancialModel
                              );
                              financialModel = newFinancialModel;



                              self.loading.nextStep = false;
                            })
                            .catch(function (error) {
                              console.log(error);
                              self.loading.nextStep = false;
                            });
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.loading.nextStep = false;
                      });
                  }
                } else {
                  onlyLocal = true;
                  $financialApiService
                    .checkRichiestaDigital(FinancialModel.build(financialModel))
                    .then(function (response) {
                      console.log(response);
                      financialModel.leasingData.preventivo.warningTit = response.warningTit;
                      if (response.esito && $portalService.isAru()) {
                        $financialApiService
                          .generateChecklistDocs(
                            FinancialModel.build(financialModel),
                            type
                          )
                          .then(function (response) {
                            if (response.success) {
                              $workflowService
                                .nextStep(
                                  FinancialModel.build(financialModel),
                                  type,
                                  onlyLocal,
                                  financialModel.taskFiliale
                                )
                                .then(function (newFinancialModel) {
                                  self.progressBar =
                                    newFinancialModel.frontEndOptions.progressBar;
                                  self.enabled.enabledBack = !newFinancialModel
                                    .frontEndOptions.disabledBack;
                                  self.enabled.enabledSave = !newFinancialModel
                                    .frontEndOptions.disabledSave;
                                  self.actionBar =
                                    newFinancialModel.frontEndOptions.actionBar;
                                  console.log(
                                    "new model returned!",
                                    newFinancialModel
                                  );
                                  financialModel = newFinancialModel;
                                  self.loading.nextStep = false;
                                })
                                .catch(function (error) {
                                  console.log(error);
                                  self.loading.nextStep = false;
                                });
                            } else {
                              self.loading.nextStep = false;
                            }
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                          });
                      } else if (response.details.showPopup) {
                        self.loading.nextStep = false;
                        $modalService.openModal("checkRichiesta-modal");
                        setCheckRichiesta(response);
                      } else {
                        $financialApiService
                          .checkOwnership(
                            FinancialModel.build(financialModel),
                            type,
                            onlyLocal,
                            financialModel.taskFiliale
                          )
                          .then(function (response) {
                            if (response.goHome) {
                              self.loading.nextStep = false;
                              $location.path("/");
                            } else {
                              $workflowService
                                .nextStep(
                                  FinancialModel.build(financialModel),
                                  type,
                                  onlyLocal,
                                  financialModel.taskFiliale
                                )
                                .then(function (newFinancialModel) {

                                  self.progressBar =
                                    newFinancialModel.frontEndOptions.progressBar;
                                  self.enabled.enabledBack = !newFinancialModel
                                    .frontEndOptions.disabledBack;
                                  self.enabled.enabledSave = !newFinancialModel
                                    .frontEndOptions.disabledSave;
                                  self.actionBar =
                                    newFinancialModel.frontEndOptions.actionBar;
                                  financialModel = newFinancialModel;


                                  self.loading.nextStep = false;
                                })
                                .catch(function (error) {
                                  console.log(error);
                                  self.loading.nextStep = false;
                                });
                            }
                          })
                          .catch(function (error) {
                            console.log(error);
                          });
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                }
              } else if (getWizardMap(financialModel.viewIndex) == "M10") {
                if (fromModal && typeOfModal == "checkListInfo") {
                  $modalService.closeModal("checkListInfo-modal");
                  self.loading.nextStep = true;
                  onlyLocal = true;
                  $financialApiService
                    .completeChecklist(
                      FinancialModel.build(financialModel),
                      type,
                      onlyLocal
                    )
                    .then(function (response) {
                      self.loading.nextStep = false;
                      if (response.success) {
                        $location.path("/");
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                } else if (fromModal && typeOfModal == "confirmClientAru") {
                  $modalService.closeModal("infoClientiAru-modal");
                  self.loading.nextStep = false;
                  $location.path("/");
                } else if (
                  $portalService.isAra() &&
                  (financialModel.leasingData.preventivo.documents.message ||
                    financialModel.leasingData.preventivo.documents.refused
                      .length > 0) &&
                  financialModel.leasingData.preventivo.status != "P415"
                ) {
                  $modalService.openModal("checkListInfo-modal");
                  self.loading.nextStep = false;
                } /* inserire la parte nuova modale */
                else if (
                  fromModal &&
                  typeOfModal == "confirmUploadCheckList"
                ) {
                  $modalService.closeModal("confirmUploadCheckList-modal");
                  self.loading.nextStep = true;
                  onlyLocal = true;
                  $financialApiService
                    .completeChecklist(
                      FinancialModel.build(financialModel),
                      type,
                      onlyLocal
                    )
                    .then(function (response) {
                      if (response.success) {
                        if ($portalService.isAru()) {
                          self.loading.nextStep = false;
                          $modalService.openModal("infoClientiAru-modal");
                        } else if (
                          response.financialModel.goHome &&
                          $portalService.isAra()
                        ) {
                          self.loading.nextStep = false;
                          $location.path("/");
                        } else {
                          $workflowService
                            .nextStep(
                              FinancialModel.build(financialModel),
                              type,
                              onlyLocal,
                              financialModel.taskFiliale
                            )
                            .then(function (newFinancialModel) {
                              self.progressBar =
                                newFinancialModel.frontEndOptions.progressBar;
                              self.enabled.enabledBack = !newFinancialModel
                                .frontEndOptions.disabledBack;
                              self.enabled.enabledSave = !newFinancialModel
                                .frontEndOptions.disabledSave;
                              self.actionBar =
                                newFinancialModel.frontEndOptions.actionBar;
                              console.log(
                                "new model returned!",
                                newFinancialModel
                              );
                              financialModel = newFinancialModel;
                              self.loading.nextStep = false;
                            })
                            .catch(function (error) {
                              console.log(error);
                              self.loading.nextStep = false;
                            });
                        }
                      } else {
                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                } /* fine parte nuova modale */
                else {
                  var checkListNotUploaded = financialModel.leasingData.preventivo.checklistDocumenti
                    .filter(function (e) {
                      return e.mandatory == true;
                    })
                    .filter(function (z) {
                      return z.uploadedFiles.length == 0;
                    });
                  if (checkListNotUploaded.length) {
                    self.loading.nextStep = false;
                    setListOfDocumentNotUploaded(checkListNotUploaded);
					$modalService.openModal("confirmUploadCheckList-modal");
                  } else {
                    onlyLocal = true;
                    $financialApiService
                      .completeChecklist(
                        FinancialModel.build(financialModel),
                        type,
                        onlyLocal
                      )
                      .then(function (response) {
                        if (response.success) {
                          if ($portalService.isAru()) {
                            self.loading.nextStep = false;
                            $modalService.openModal("infoClientiAru-modal");
                          } else if (
                            response.financialModel.goHome &&
                            $portalService.isAra()
                          ) {
                            self.loading.nextStep = false;
                            $location.path("/");
                          } else {
                            $workflowService
                              .nextStep(
                                FinancialModel.build(financialModel),
                                type,
                                onlyLocal,
                                financialModel.taskFiliale
                              )
                              .then(function (newFinancialModel) {
                                self.progressBar =
                                  newFinancialModel.frontEndOptions.progressBar;
                                self.enabled.enabledBack = !newFinancialModel
                                  .frontEndOptions.disabledBack;
                                self.enabled.enabledSave = !newFinancialModel
                                  .frontEndOptions.disabledSave;
                                self.actionBar =
                                  newFinancialModel.frontEndOptions.actionBar;
                                console.log(
                                  "new model returned!",
                                  newFinancialModel
                                );
                                financialModel = newFinancialModel;
                                self.loading.nextStep = false;
                              })
                              .catch(function (error) {
                                console.log(error);
                                self.loading.nextStep = false;
                              });
                          }
                        } else {
                          self.loading.nextStep = false;
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.loading.nextStep = false;
                      });
                  }
                }
              } else if (getWizardMap(financialModel.viewIndex) == "MP2") {
                $modalService.openModal("digitalQuoteCreationModal");
                self.loading.nextStep = false;
              } else if (getWizardMap(financialModel.viewIndex) == "M13a") {
                onlyLocal = false;

                if (
                  !financialModel.financialCustomer.metadata
                    .venditaDistanzaPolizza &&
                  fromModal &&
                  $portalService.isAru()
                ) {
                  setAcceptMode(true);
                  self.loading.nextStep = false;
                } else {
                  onlyLocal = true;
                  $workflowService
                    .nextStep(
                      FinancialModel.build(financialModel),
                      type,
                      onlyLocal,
                      financialModel.taskFiliale
                    )
                    .then(function (newFinancialModel) {
                      self.progressBar =
                        newFinancialModel.frontEndOptions.progressBar;
                      self.enabled.enabledBack = !newFinancialModel
                        .frontEndOptions.disabledBack;
                      self.enabled.enabledSave = !newFinancialModel
                        .frontEndOptions.disabledSave;
                      self.actionBar =
                        newFinancialModel.frontEndOptions.actionBar;
                      console.log("new model returned!", newFinancialModel);
                      financialModel = newFinancialModel;
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                }
              } else if (getWizardMap(financialModel.viewIndex) == "M15") {
                if (fromModal && typeOfModal == "checkRichiestaModal") {
                  $modalService.closeModal("checkRichiesta-modal");
                  self.loading.nextStep = true;
                  onlyLocal = false;
                  $financialApiService
                    .checkIdentificazione(FinancialModel.build(financialModel))
                    .then(function (response) {
                      self.responseCheckIdentificazione = response;
                      var trasferToModal = self.responseCheckIdentificazione;
                      Object.assign(trasferToModal, {
                        fromDigitalModule: true,
                      });

                      if (response.required) {
                        $transactionFactory.set(trasferToModal);
                        self.dichiarazioneRiconoscimento = response;
                        $rootScope.openModalIdentificazione = true;
                        self.loading.nextStep = false;
                        $("#footerInstant").css("z-index", "-1");
                        $(".financial-leasing__footer").css("z-index", "-1");
                        $timeout(function () {
                          $modalService.openModal("dichIdentFirm-modal");
                        }, 1000);
                      } else {
                        $transactionFactory.clear();
                        Object.assign(self.responseCheckIdentificazione, {
                          'practiceId': financialModel.leasingData.id
                        })
                        $financialApiService
                          .saveIdentificazione(self.responseCheckIdentificazione)
                          .then(function (response) {
                            $financialApiService
                              .submitLoadContract(
                                FinancialModel.build(financialModel),
                                type,
                                onlyLocal
                              )
                              .then(function (response) {
                                if (response.success) {

                                  if (response.showPopup) {
                                    setResponseSubmitLoadContract(response);
                                    $("#footerInstant").css("z-index", "-1");
                                    $(".financial-leasing__footer").css("z-index", "-1");
                                    $timeout(function () {
                                      $modalService.openModal("popUpSubmitLoadContract-modal");
                                    }, 1000);

                                  } else {
                                    $location.path("/");
                                  }


                                }
                                self.loading.nextStep = false;
                              })
                              .catch(function (error) {
                                console.log(error);
                                self.loading.nextStep = false;
                              });
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                          });
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                    });
                } else if (fromModal && typeOfModal == "dichiarazioneModal") {
                  self.loading.nextStep = true;
                  onlyLocal = false;
                  $rootScope.openModalIdentificazione = false;
                  self.responseCheckIdentificazione = $transactionFactory.get();
                  $transactionFactory.clear();
                  Object.assign(self.responseCheckIdentificazione, {
                    'practiceId': financialModel.leasingData.id
                  })
                  $financialApiService
                    .saveIdentificazione(self.responseCheckIdentificazione)
                    .then(function (response) {
                      $financialApiService
                        .submitLoadContract(
                          FinancialModel.build(financialModel),
                          type,
                          onlyLocal
                        )
                        .then(function (response) {
                          if (response.success) {
                            if (response.showPopup) {
                              setResponseSubmitLoadContract(response);
                              $("#footerInstant").css("z-index", "-1");
                              $(".financial-leasing__footer").css("z-index", "-1");
                              $timeout(function () {
                                $modalService.openModal("popUpSubmitLoadContract-modal");
                              }, 1000);

                            } else {
                              $location.path("/");
                            }
                          }
                          self.loading.nextStep = false;
                        })
                        .catch(function (error) {
                          console.log(error);
                          self.loading.nextStep = false;
                        });
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    })
                } else if (checkGaranti() && !fromModal) {
                  self.loading.nextStep = false;
                  $("#footerInstant").css("z-index", "-1");
                  $(".financial-leasing__footer").css("z-index", "-1");
                  $timeout(function () {
                    $modalService.openModal("check-garante-modal");
                  }, 1000);
                } else if (fromModal && typeOfModal == "popUpSubmitLoadContractModal") {
                  var modelOfSubmitContract = JSON.parse(getResponseSubmitLoadContract().workflowSoapPojo.dynObj);
                  var showPopup = true;
                  $financialApiService
                    .submitLoadContract(
                      FinancialModel.build(modelOfSubmitContract),
                      type,
                      onlyLocal,
                      showPopup
                    )
                    .then(function (response) {
                      if (response.success) {
                        if (response.showPopup) {
                          setResponseSubmitLoadContract(response);
                          $("#footerInstant").css("z-index", "-1");
                          $(".financial-leasing__footer").css("z-index", "-1");
                          $timeout(function () {
                            $modalService.openModal("popUpSubmitLoadContract-modal");
                          }, 1000);

                        } else {
                          $location.path("/");
                        }
                      }
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });

                } else {
                  self.loading.nextStep = true;
                  onlyLocal = false;
                  $financialApiService
                    .checkRichiestaDigital(FinancialModel.build(financialModel))
                    .then(function (response) {
                      console.log(response);
                      if (response.esito) {
                        $financialApiService
                          .checkIdentificazione(
                            FinancialModel.build(financialModel)
                          )
                          .then(function (response) {
                            self.responseCheckIdentificazione = response;
                            var trasferToModal =
                              self.responseCheckIdentificazione;
                            Object.assign(trasferToModal, {
                              fromDigitalModule: true,
                            });

                            if (response.required) {
                              $transactionFactory.set(trasferToModal);
                              self.dichiarazioneRiconoscimento = response;
                              $rootScope.openModalIdentificazione = true;
                              self.loading.nextStep = false;
                              $("#footerInstant").css("z-index", "-1");
                              $(".financial-leasing__footer").css(
                                "z-index",
                                "-1"
                              );
                              $timeout(function () {
                                $modalService.openModal("dichIdentFirm-modal");
                              }, 1000);
                            } else {
                              $transactionFactory.clear();
                              Object.assign(self.responseCheckIdentificazione, {
                                'practiceId': financialModel.leasingData.id
                              })
                              $financialApiService
                                .saveIdentificazione(self.responseCheckIdentificazione)
                                .then(function (response) {
                                  $financialApiService
                                    .submitLoadContract(
                                      FinancialModel.build(financialModel),
                                      type,
                                      onlyLocal
                                    )
                                    .then(function (response) {
                                      if (response.success) {
                                        if (response.showPopup) {
                                          setResponseSubmitLoadContract(response);
                                          $("#footerInstant").css("z-index", "-1");
                                          $(".financial-leasing__footer").css("z-index", "-1");
                                          $timeout(function () {
                                            $modalService.openModal("popUpSubmitLoadContract-modal");
                                          }, 1000);

                                        } else {
                                          $location.path("/");
                                        }
                                      }
                                      self.loading.nextStep = false;
                                    })
                                    .catch(function (error) {
                                      console.log(error);
                                      self.loading.nextStep = false;
                                    });
                                })
                                .catch(function (error) {
                                  console.log(error);
                                  self.loading.nextStep = false;
                                });
                            }
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                          });
                      } else if (response.details.showPopup) {
                        self.loading.nextStep = false;
                        $modalService.openModal("checkRichiesta-modal");
                        setCheckRichiesta(response);
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                }
              } else if (getWizardMap(financialModel.viewIndex) == "D1") {
                $modalService.openModal("modalConfirmDeroga");
                self.loading.nextStep = false;
              } else if (getWizardMap(financialModel.viewIndex) == "M16") {
                var onlyLocal = false;
                self.loading.nextStep = true;
                if (!fromModal && !financialModel.leasingData.preventivo.deliberaBanca.deliberaPositiva) {
                  $("#footerInstant").css("z-index", "-1");
                  $(".financial-leasing__footer").css("z-index", "-1");
                  $modalService.openModal("deliberaNegativa-modal");
                  self.loading.nextStep = false;
                } else if (fromModal && typeOfModal == 'deliberaNegativa') {
                  $modalService.closeModal("deliberaNegativa-modal");
                  $simulationService
                    .submitDeliberaBancaAsync(
                      FinancialModel.build(financialModel),
                      type,
                      onlyLocal
                    )
                    .then(function (response) {
                      if (response.success) {
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                        $location.path("/");
                      } else {
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                      }
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      self.loading.nextStep = false;
                      console.log("ERROR:", error);
                      $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE",
                      });
                    })
                } else {
                  self.loading.nextStep = true;
                  $simulationService.checkSubmitDelBanca(FinancialModel.build(financialModel), type, onlyLocal)
                    .then(function (response) {
                      if (response.success && response.details.showPopup) {

                        self.loading.nextStep = false;
                        $("#footerInstant").css("z-index", "-1");
                        $(".financial-leasing__footer").css("z-index", "-1");
                        $timeout(function () {
                          $modalService.openModal("resolutionNuovoPrestoLeasingModal");
                        }, 200)
                        setResponsecheckSubmitDelBanca(response.details);
                      } else {
                        self.loading.nextStep = false;
                        $rootScope.$broadcast("addAlert", {
                          text: "ERROR_QUERY"
                        });
                      }

                    }).catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    })

                }

              } else if (getWizardMap(financialModel.viewIndex) == "M9") {
                if (fromModal) {
                  $modalService.closeModal(typeOfModal);
                  $rootScope.$broadcast("pageLoader", {
                    action: "OPEN",
                  });
                  $financialApiService
                    .sendAccept(FinancialModel.build(financialModel), type, true)
                    .then(function (response) {
                      if (response.success) {
                        if (response.goHome) {
                          $modalService.closeModal(typeOfModal);
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE",
                          });
                          self.loading.nextStep = false;
                          $location.path("/");
                        } else {
                          var snapshot = response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
                          var metadata = JSON.parse(snapshot.metadata);
                          var modelAfterSendAccept = FinancialModel.build(metadata.dynamicInputPojo);

                          $workflowService
                            .nextStep(FinancialModel.build(modelAfterSendAccept), type, true, modelAfterSendAccept.taskFiliale)
                            .then(function (newFinancialModel) {
                              setLoader(false);
                              setEnabledButtons(true);
                              $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE",
                              });
                              self.progressBar =
                                newFinancialModel.frontEndOptions.progressBar;
                              self.enabled.enabledBack = !newFinancialModel
                                .frontEndOptions.disabledBack;
                              self.enabled.enabledSave = !newFinancialModel
                                .frontEndOptions.disabledSave;
                              self.actionBar =
                                newFinancialModel.frontEndOptions.actionBar;
                              financialModel = newFinancialModel;
                              $modalService.closeModal(typeOfModal);
                              self.loading.nextStep = false;
                            })
                            .catch(function () {
                              setLoader(false);
                              setEnabledButtons(true);
                              $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE",
                              });
                            });
                        }
                      } else if (!response.success && response.keyMessage == 'ACCETTAZIONE_CON_DEROGA_KO') {
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                        $modalService.openModal("derogaKOModal");
                      } else {
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function () {
                      setLoader(false);
                      setEnabledButtons(true);
                      $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE",
                      });
                      self.loading.nextStep = false;
                    });

                } else {
                  var ndgUser = financialModel.financialVendor.riUserG.ndg;
                  var userCustomer = financialModel.financialCustomer.metadata.riUserG.ndg;

                  financialModel.leasingData.preventivo.contatti.riferimenti
                    .find(function (element) {
                      return (element.id == "BANCA")
                    }).ndg = ndgUser;

                  financialModel.leasingData.preventivo.contatti.riferimenti
                    .find(function (element) {
                      return (element.id == "CLIENTE")
                    }).ndg = userCustomer;

                  $financialApiService
                    .saveUpdateContacts(financialModel.leasingData.preventivo.contatti)
                    .then(function (response) {
                      console.log(response)
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                  $financialApiService
                    .validateRating(FinancialModel.build(financialModel))
                    .then(function (response) {
                      if (response.canAccept) {
                        $("#footerInstant").css("z-index", "-1");
                        $(".financial-leasing__footer").css("z-index", "-1");
                        if (financialModel.leasingData.preventivo.isTargato && $portalService.isAra()) {
                          $modalService.openModal("targatoAcceptanceModal");
                        } else {
                          $modalService.openModal("modalRatingDetail");
                        }
                      } else if (!response.canAccept && response.warningEsito === "LBL_ESITO_KO") {
                        $("#footerInstant").css("z-index", "-1");
                        $(".financial-leasing__footer").css("z-index", "-1");
                        $modalService.openModal("modalRatingDetailModifica");
                      } else if (!response.canAccept && response.warningEsito === "LBL_RATING_KO") {
                        $("#footerInstant").css("z-index", "-1");
                        $(".financial-leasing__footer").css("z-index", "-1");
                        $modalService.openModal("modalRatingDetailAnnulla");
                      }
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });

                }

              } else if (getWizardMap(financialModel.viewIndex) == "M17") {
                onlyLocal = false;
                self.loading.nextStep = true;
                $financialApiService
                  .confirmContractChecklist(
                    FinancialModel.build(financialModel),
                    type,
                    onlyLocal
                  )
                  .then(function (response) {
                    if (response.success) {
                      $location.path("/");
                    }
                    self.loading.nextStep = false;
                  })
                  .catch(function (error) {
                    console.log(error);
                    self.loading.nextStep = false;
                  });
              } else if (getWizardMap(financialModel.viewIndex) == "BEI11") {
                console.log("model questionario bei", modelQuestionarioBei);
                if ($portalService.isAru()) {
                  $notificationService
                    .submitQuestBeiDigital(
                      modelQuestionarioBei.id,
                      modelQuestionarioBei.functionId,
                      modelQuestionarioBei.ndg,
                      modelQuestionarioBei.societaRichiedente,
                      modelQuestionarioBei.indirizzo,
                      modelQuestionarioBei.codiceFiscale,
                      modelQuestionarioBei.partitaIva,
                      modelQuestionarioBei.rb1,
                      modelQuestionarioBei.rb2,
                      modelQuestionarioBei.rb3,
                      modelQuestionarioBei.rb4,
                      modelQuestionarioBei.numDipendenti,
                      modelQuestionarioBei.codiceAteco,
                      modelQuestionarioBei.rb5,
                      modelQuestionarioBei.periodo,
                      modelQuestionarioBei.rb6,
                      modelQuestionarioBei.importo,
                      modelQuestionarioBei.quotaImportoGreen,
                      modelQuestionarioBei.macroSettore,
                      modelQuestionarioBei.settore,
                      modelQuestionarioBei.categoriaSottoprogetto,
                      modelQuestionarioBei.valoreIndicatore,
                      modelQuestionarioBei.descrizione,
                      modelQuestionarioBei.preventivo,
                      modelQuestionarioBei.anno,
                      modelQuestionarioBei.indirizzoCompleto,
                      modelQuestionarioBei.comune,
                      modelQuestionarioBei.provincia,
                      modelQuestionarioBei.cap,
                      modelQuestionarioBei.stato,
                      modelQuestionarioBei.convenzione,
                      false,
                      null,
                      modelQuestionarioBei.questionario,
                      modelQuestionarioBei.cdPrd,
                      modelQuestionarioBei.agevolazione1,
                      modelQuestionarioBei.agevolazione2,
                      modelQuestionarioBei.numeroContratto,
                      modelQuestionarioBei.modulo,
                      modelQuestionarioBei.tipoModulo,
                      modelQuestionarioBei.internal,
                      modelQuestionarioBei.emailCli,
                      financialModel.leasingData.id
                    )
                    .then(function (response) {
                      console.log("response submitQuestBeiDigital", response);
                      if (response.success) {
                        $workflowService
                          .nextStep(
                            FinancialModel.build(financialModel),
                            type,
                            true,
                            financialModel.taskFiliale
                          )
                          .then(function (newFinancialModel) {
                            self.progressBar =
                              newFinancialModel.frontEndOptions.progressBar;
                            self.enabled.enabledBack = !newFinancialModel
                              .frontEndOptions.disabledBack;
                            self.enabled.enabledSave = !newFinancialModel
                              .frontEndOptions.disabledSave;
                            self.actionBar =
                              newFinancialModel.frontEndOptions.actionBar;
                            console.log("new model returned!", newFinancialModel);
                            financialModel = newFinancialModel;
                            self.loading.nextStep = false;
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                          });
                      } else {
                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });

                } else {
                  $workflowService
                    .nextStep(
                      FinancialModel.build(financialModel),
                      type,
                      true,
                      financialModel.taskFiliale
                    )
                    .then(function (newFinancialModel) {
                      self.progressBar =
                        newFinancialModel.frontEndOptions.progressBar;
                      self.enabled.enabledBack = !newFinancialModel
                        .frontEndOptions.disabledBack;
                      self.enabled.enabledSave = !newFinancialModel
                        .frontEndOptions.disabledSave;
                      self.actionBar =
                        newFinancialModel.frontEndOptions.actionBar;
                      console.log("new model returned!", newFinancialModel);
                      financialModel = newFinancialModel;
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });

                }

              } else if (getWizardMap(financialModel.viewIndex) == "M8") {
                self.loading.nextStep = true;
                var onlyLocal = false;
                if (fromModal) {
                  financialModel.leasingData.preventivo.nuovoPrestoleasingConDeroga = false;
                  $modalService.closeModal("questionarioNplAccept-modal");
                  $modalService.closeModal("targatoAcceptanceModal");
                  var onlyCheck = false;
                  onlyLocal = true;
                  $financialApiService
                    .checkQuestNpl(FinancialModel.build(financialModel), type, onlyLocal, onlyCheck)
                    .then(function (response) {
                      if (response.success) {
                        if (response.goHome) {
                          $location.path('/');
                          return
                        }
                        var modelAftercheckQuestNpl = FinancialModel.build(JSON.parse(response.workflowSoapPojo.dynObj));
                        $workflowService
                          .nextStep(
                            FinancialModel.build(modelAftercheckQuestNpl),
                            type,
                            onlyLocal,
                            modelAftercheckQuestNpl.taskFiliale
                          )
                          .then(function (newFinancialModel) {
                            self.progressBar =
                              newFinancialModel.frontEndOptions.progressBar;
                            self.enabled.enabledBack = !newFinancialModel
                              .frontEndOptions.disabledBack;
                            self.enabled.enabledSave = !newFinancialModel
                              .frontEndOptions.disabledSave;
                            self.actionBar =
                              newFinancialModel.frontEndOptions.actionBar;
                            console.log("new model returned!", newFinancialModel);
                            financialModel = newFinancialModel;
                            self.loading.nextStep = false;
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                          });
                      }
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      self.loading.nextStep = false;
                    })

                } else {
                  var onlyCheck = true;
                  $financialApiService
                    .checkQuestNpl(FinancialModel.build(financialModel), type, onlyLocal, onlyCheck)
                    .then(function (response) {
                      if (response.success) {
                        if (response.goHome) {
                          $location.path('/');
                          return;
                        }
                        var modelAftercheckQuestNpl = FinancialModel.build(JSON.parse(response.workflowSoapPojo.dynObj));
                        if (response.frontEndOptions.actionType != 'CONFIRM') {
                          $workflowService
                            .nextStep(
                              FinancialModel.build(modelAftercheckQuestNpl),
                              type,
                              onlyLocal,
                              modelAftercheckQuestNpl.taskFiliale
                            )
                            .then(function (newFinancialModel) {
                              self.progressBar =
                                newFinancialModel.frontEndOptions.progressBar;
                              self.enabled.enabledBack = !newFinancialModel
                                .frontEndOptions.disabledBack;
                              self.enabled.enabledSave = !newFinancialModel
                                .frontEndOptions.disabledSave;
                              self.actionBar =
                                newFinancialModel.frontEndOptions.actionBar;
                              console.log("new model returned!", newFinancialModel);
                              financialModel = newFinancialModel;
                              self.loading.nextStep = false;
                            })
                            .catch(function (error) {
                              console.log(error);
                              self.loading.nextStep = false;
                            });

                        } else {
                          self.loading.nextStep = false;
                          if (financialModel.leasingData.preventivo.isTargato && $portalService.isAra()) {
                            $modalService.openModal("targatoAcceptanceModal");
                          } else {
                            $modalService.openModal("questionarioNplAccept-modal");
                          }
                        }
                      } else {
                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function (error) {
                      self.loading.nextStep = false;
                    })

                }


              } else if (getWizardMap(financialModel.viewIndex) == "MPL") {
                self.loading.nextStep = true;
                if (financialModel.responseModuloNplInfo.showPopupOnNext && !fromModal) {
                  $("#footerInstant").css("z-index", "-1");
                  $(".financial-leasing__footer").css("z-index", "-1");
                  $modalService.openModal("mappaPrestoLeasing-modal");
                  self.loading.nextStep = false;
                } else {
                  $modalService.closeModal("mappaPrestoLeasing-modal");
                  financialModel.leasingData.preventivo.deliberaBanca.moduloInfoBanca.reteOperatore = userInfo.reteVendita;
                  $simulationService.submitModuloNpl(FinancialModel.build(financialModel))
                    .then(function (response) {
                      if (response.success) {
                        var onlyLocal = true;
                        $workflowService
                          .nextStep(
                            FinancialModel.build(financialModel),
                            type,
                            onlyLocal,
                            financialModel.taskFiliale
                          )
                          .then(function (newFinancialModel) {
                            self.progressBar =
                              newFinancialModel.frontEndOptions.progressBar;
                            self.enabled.enabledBack = !newFinancialModel
                              .frontEndOptions.disabledBack;
                            self.enabled.enabledSave = !newFinancialModel
                              .frontEndOptions.disabledSave;
                            self.actionBar =
                              newFinancialModel.frontEndOptions.actionBar;
                            console.log("new model returned!", newFinancialModel);
                            financialModel = newFinancialModel;
                            self.loading.nextStep = false;
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                          });

                      } else {
                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function (error) {
                      self.loading.nextStep = false;
                    })

                }

              } else if (getWizardMap(financialModel.viewIndex) == "M7") {
                if (financialModel.exitNpl && !fromModal) {
                  $("#footerInstant").css("z-index", "-1");
                  $(".financial-leasing__footer").css("z-index", "-1");
                  $modalService.openModal("preventive-accept-modal");
                  self.loading.nextStep = false;
                } else {
                  onlyLocal = true;

                  $workflowService
                    .nextStep(
                      FinancialModel.build(financialModel),
                      type,
                      onlyLocal,
                      financialModel.taskFiliale
                    )
                    .then(function (newFinancialModel) {
                      self.progressBar =
                        newFinancialModel.frontEndOptions.progressBar;
                      self.enabled.enabledBack = !newFinancialModel
                        .frontEndOptions.disabledBack;
                      self.enabled.enabledSave = !newFinancialModel
                        .frontEndOptions.disabledSave;
                      self.actionBar =
                        newFinancialModel.frontEndOptions.actionBar;
                      console.log("new model returned!", newFinancialModel);
                      financialModel = newFinancialModel;
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });

                }
              } else if (getWizardMap(financialModel.viewIndex) == "DNPL") {
                self.loading.nextStep = true;
                financialModel.leasingData.preventivo.deliberaBanca.moduloInfoBanca.reteOperatore = userInfo.reteVendita;
                var onlyLocal = true;
                if (financialModel.leasingData.preventivo.nuovoPrestoleasingConDeroga) {
                  $workflowService
                    .nextStep(
                      FinancialModel.build(financialModel),
                      type,
                      onlyLocal,
                      financialModel.taskFiliale
                    )
                    .then(function (newFinancialModel) {
                      self.progressBar =
                        newFinancialModel.frontEndOptions.progressBar;
                      self.enabled.enabledBack = !newFinancialModel
                        .frontEndOptions.disabledBack;
                      self.enabled.enabledSave = !newFinancialModel
                        .frontEndOptions.disabledSave;
                      self.actionBar =
                        newFinancialModel.frontEndOptions.actionBar;
                      console.log("new model returned!", newFinancialModel);
                      financialModel = newFinancialModel;
                      self.loading.nextStep = false;
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    });
                } else {
                  $modalService.openModal("preventive-accept-modal");
                  self.loading.nextStep = false;
                }
              } else if (getWizardMap(financialModel.viewIndex) == "M14") {
                addNewValueIntoModelADV();
                self.loading.nextStep = true;
                onlyLocal = true;
                // INIZIO - Modale armamenti
                if(modelQuestAdv.metadataAdv.note.noteCommon.domandaArmamenti 
                    && !fromModal
                    && !modelQuestAdv.metadataAdv.note.noteCommon.domandaArmamentiConferma) {
                  $modalService.openModal("domandaArmamenti-modal");
                  return;
                } else if(modelQuestAdv.metadataAdv.note.noteCommon.domandaArmamenti 
                    && fromModal && typeOfModal == "domandaArmamentiModal"){
                    modelQuestAdv.metadataAdv.note.noteCommon.domandaArmamentiConferma = true;
                  $modalService.closeModal("domandaArmamenti-modal");
                }
                // FINE - Modale armamenti
                if (fromModal && typeOfModal == "validateQuestAdvModal") {
                  $modalService.closeModal("validateQuestAdv-modal");
                  modelQuestAdv.warningForzatura = true;
                  $uniService.submitQuestADVDigital(modelQuestAdv)
                    .then(function (response) {
                      if (response.success) {
                        if (response.keyMessage && response.keyMessage == 'WARNING_ADV_PRV') {
                          $rootScope.$broadcast("addAlert", {
                            text: "WARNING_ADV_PRV"
                          })
                        } else if (response.keyMessage && response.keyMessage == 'WARNING_ADV_CORREZIONE') {
                          $rootScope.$broadcast("addAlert", {
                            text: "WARNING_ADV_CORREZIONE"
                          })

                        } else {
                          $rootScope.$broadcast("addAlert", {
                            text: "MSG_ADV_OK"
                          })
                        }
                        financialModel.financialCustomer.metadata.riUserF.listaPf = response.listaPf;
                        financialModel.financialCustomer.metadata.adeguataVerifica.idQuest = response.idQuest;
                        $workflowService
                          .nextStep(
                            FinancialModel.build(financialModel),
                            type,
                            onlyLocal,
                            financialModel.taskFiliale
                          )
                          .then(function (newFinancialModel) {
                            self.progressBar =
                              newFinancialModel.frontEndOptions.progressBar;
                            self.enabled.enabledBack = !newFinancialModel
                              .frontEndOptions.disabledBack;
                            self.enabled.enabledSave = !newFinancialModel
                              .frontEndOptions.disabledSave;
                            self.actionBar =
                              newFinancialModel.frontEndOptions.actionBar;
                            console.log(
                              "new model returned!",
                              newFinancialModel
                            );
                            financialModel = newFinancialModel;
                            self.loading.nextStep = false;
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                          });

                      } else {

                        self.loading.nextStep = false;
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                      self.loading.nextStep = false;
                    })

                } else {
                  $uniService.validateRequestAdv(modelQuestAdv)
                    .then(function (response) {
                      if (response.details.showPopup) {
                        self.loading.nextStep = false;
                        setResponseValidateADV(response);
                        $modalService.openModal("validateQuestAdv-modal");

                      } else {
                        $uniService.submitQuestADVDigital(modelQuestAdv)
                          .then(function (response) {
                            if (response.success) {
                              if (response.keyMessage && response.keyMessage == 'WARNING_ADV_PRV') {
                                $rootScope.$broadcast("addAlert", {
                                  text: "WARNING_ADV_PRV"
                                })
                              } else if (response.keyMessage && response.keyMessage == 'WARNING_ADV_CORREZIONE') {
                                $rootScope.$broadcast("addAlert", {
                                  text: "WARNING_ADV_CORREZIONE"
                                })

                              } else {
                                $rootScope.$broadcast("addAlert", {
                                  text: "MSG_ADV_OK"
                                })
                              }
                              financialModel.financialCustomer.metadata.riUserF.listaPf = response.listaPf;
                              financialModel.financialCustomer.metadata.adeguataVerifica.idQuest = response.idQuest;
                              $workflowService
                                .nextStep(
                                  FinancialModel.build(financialModel),
                                  type,
                                  onlyLocal,
                                  financialModel.taskFiliale
                                )
                                .then(function (newFinancialModel) {
                                  self.progressBar =
                                    newFinancialModel.frontEndOptions.progressBar;
                                  self.enabled.enabledBack = !newFinancialModel
                                    .frontEndOptions.disabledBack;
                                  self.enabled.enabledSave = !newFinancialModel
                                    .frontEndOptions.disabledSave;
                                  self.actionBar =
                                    newFinancialModel.frontEndOptions.actionBar;
                                  console.log(
                                    "new model returned!",
                                    newFinancialModel
                                  );
                                  financialModel = newFinancialModel;
                                  self.loading.nextStep = false;
                                })
                                .catch(function (error) {
                                  console.log(error);
                                  self.loading.nextStep = false;
                                });

                            } else {
                              self.loading.nextStep = false;
                            }
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loading.nextStep = false;
                          })

                      }

                    })
                    .catch(function (error) {
                      self.loading.submit = false;
                    })
                }
              } else {
                /**
                 * call nextStep instead
                 */
                onlyLocal = true;

                $workflowService
                  .nextStep(
                    FinancialModel.build(financialModel),
                    type,
                    onlyLocal,
                    financialModel.taskFiliale
                  )
                  .then(function (newFinancialModel) {
                    self.progressBar =
                      newFinancialModel.frontEndOptions.progressBar;
                    self.enabled.enabledBack = !newFinancialModel
                      .frontEndOptions.disabledBack;
                    self.enabled.enabledSave = !newFinancialModel
                      .frontEndOptions.disabledSave;
                    self.actionBar =
                      newFinancialModel.frontEndOptions.actionBar;
                    console.log("new model returned!", newFinancialModel);
                    financialModel = newFinancialModel;
                    self.loading.nextStep = false;
                  })
                  .catch(function (error) {
                    console.log(error);
                    self.loading.nextStep = false;
                  });
              }
            }, 2500);
          },
          back: function (fromNewCustomerForm) {
            var self = this;

            if (fromNewCustomerForm) {
              self.loading.backStep = true;
              self.showOldForm = true;
              self.loading.backStep = false;
            } else {
              jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar(
                "scrollTo",
                0
              ); //posiziona la scollBar in top ad ogni cambio vista
              self.loading.backStep = true;
              /**
               * call backStep
               */
              $timeout(function () {
                var onlyLocal = true;
                financialModel.leasingData.preventivo.assicurazioni = financialModel.leasingData.preventivo.assicurazioni.filter(
                  function (element) {
                    return element != "";
                  }
                );
                $workflowService
                  .backStep(financialModel, type, onlyLocal, financialModel.taskFiliale)
                  .then(function (newFinancialModel) {
                    self.progressBar =
                      newFinancialModel.frontEndOptions.progressBar;
                    self.enabled.enabledBack = !newFinancialModel
                      .frontEndOptions.disabledBack;
                    self.enabled.enabledSave = !newFinancialModel
                      .frontEndOptions.disabledSave;
                    self.actionBar =
                      newFinancialModel.frontEndOptions.actionBar;
                    console.log("new model returned: ", newFinancialModel);
                    financialModel = newFinancialModel;
                  })
                  .finally(function () {
                    self.loading.backStep = false;
                  });
              }, 2500);
            }
          },
          suspend: function () {
            navigator.loading.suspension = true;
            var onlyLocal = true;
            financialModel.leasingData.preventivo.assicurazioni = financialModel.leasingData.preventivo.assicurazioni.filter(
              function (element) {
                return element != "";
              }
            );
            if (getWizardMap(financialModel.viewIndex) == "M14") {
              $rootScope.$broadcast('suspendDigitalLeasing');
            } else {
              $workflowService
                .suspendInstance(
                  financialModel,
                  type,
                  onlyLocal,
                  financialModel.taskFiliale
                )
                .then(function (success) {
                  if (success) {
                    $modalService.closeModal("suspendInstance");
                    navigator.loading.suspend = false;
                    $location.path("/");
                  }
                  navigator.loading.suspend = false;
                })
                .catch(function (err) {
                  console.log(
                    "suspend instance failed! Error cause was: " + err
                  );
                  navigator.loading.suspend = false;
                })
                .finally(function () {
                  navigator.loading.suspension = false;
                });
            }

          },

          goToHomePage: function (typeOfModal) {
            $modalService.closeModal(typeOfModal);
            $location.path("/");
          },

          sendPreventiveAccept: function (nameModal) {
            if (typeof nameModal != undefined && nameModal == 'derogaKOModal') {
              financialModel.leasingData.preventivo.nuovoPrestoleasingConDeroga = false;
            }
            var self = this;
            var onlyLocal = false;
            self.loading.nextStep = true;
            $rootScope.$broadcast("pageLoader", {
              action: "OPEN",
            });
            $modalService.closeModal(nameModal);
            $financialApiService
              .sendAccept(FinancialModel.build(financialModel), type, onlyLocal)
              .then(function (response) {
                if (response.success) {
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });

                  if (response.goHome) {
                    self.loading.nextStep = false;
                    $location.path("/");
                  } else {

                    var onlyLocal = true;
                    var snapshot = response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
                    var metadata = JSON.parse(snapshot.metadata);
                    var modelAfterSendAccept = FinancialModel.build(metadata.dynamicInputPojo);

                    $workflowService
                      .nextStep(
                        FinancialModel.build(modelAfterSendAccept),
                        type,
                        onlyLocal,
                        modelAfterSendAccept.taskFiliale
                      )
                      .then(function (newFinancialModel) {
                        self.progressBar =
                          newFinancialModel.frontEndOptions.progressBar;
                        self.enabled.enabledBack = !newFinancialModel
                          .frontEndOptions.disabledBack;
                        self.enabled.enabledSave = !newFinancialModel
                          .frontEndOptions.disabledSave;
                        self.actionBar =
                          newFinancialModel.frontEndOptions.actionBar;
                        console.log("new model returned!", newFinancialModel);
                        financialModel = newFinancialModel;
                        self.loading.nextStep = false;
                      })
                      .catch(function () {
                        self.loading.nextStep = false;
                      });
                  }
                } else {
                  self.loading.nextStep = false;
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });
                }

              })
              .catch(function (error) {
                self.loading.nextStep = false;
                console.log("ERROR:", error);
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              });
          },

          sendRequestToGetNuovoPrestoLeasingResolution: function (modalClose, printBackground) {
            var self = this;
            var onlyLocal = false;
            $rootScope.$broadcast("pageLoader", {
              action: "OPEN",
            });
            $modalService.closeModal(modalClose);
            if ((financialModel.leasingData.preventivo.prodotto.id == 'IMM' && userInfo.reteVendita == 1 && getWizardMap(financialModel.viewIndex) == "M16")) {
              printBackground = true;
            }
            if (printBackground) {
              $simulationService
                .submitDeliberaBancaAsync(
                  FinancialModel.build(financialModel),
                  type,
                  onlyLocal
                )
                .then(function (response) {
                  if (response.success) {
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });
                    $location.path("/");
                  } else {
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });
                  }
                })
                .catch(function (error) {
                  console.log("ERROR:", error);
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });
                })
            } else {
              $simulationService
                .sendRequestForNplResolution(
                  FinancialModel.build(financialModel),
                  type,
                  onlyLocal
                )
                .then(function (response) {
                  if (response.success && !response.goHome) {
                    var snapshot = response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
                    var metadata = JSON.parse(snapshot.metadata);
                    var modelAfterSendRequestForNplResolution = FinancialModel.build(metadata.dynamicInputPojo);

                    $workflowService
                      .nextStep(FinancialModel.build(modelAfterSendRequestForNplResolution), type, true, modelAfterSendRequestForNplResolution.taskFiliale)
                      .then(function (newFinancialModel) {
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                        self.progressBar = newFinancialModel.frontEndOptions.progressBar;
                        self.enabled.enabledBack = !newFinancialModel.frontEndOptions.disabledBack;
                        self.enabled.enabledSave = !newFinancialModel.frontEndOptions.disabledSave;
                        self.actionBar = newFinancialModel.frontEndOptions.actionBar;
                        financialModel = newFinancialModel;
                      })
                      .catch(function () {
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                      });

                  } else if (response.goHome) {
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });
                    $location.path("/");
                  } else {
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });
                  }

                })
                .catch(function (error) {
                  console.log("ERROR:", error);
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });
                })
            }
          },

          sendRequestToRejectArcAssurances: function () {
            $rootScope.$broadcast("pageLoader", {
              action: "OPEN",
            });

            $simulationService
              .rejectArcAssurances(financialModel.leasingData.id)
              .then(function (response) {
                if (response.success) {
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });
                  $location.path("/");
                } else {
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });
                  $rootScope.$broadcast("addAlert", {
                    text: "ERROR_GENERIC"
                  });
                }
              })
              .catch(function (error) {
                console.log("ERROR: ", error);
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
                $rootScope.$broadcast("addAlert", {
                  text: "ERROR_GENERIC"
                });
              });
          },

          goToAnagCliFn: function () {
            var self = this;
            var onlyLocal = true;
            self.loading.backStep = true;
            self.restgoToStepDigitalFinish = false;
            $workflowService
              .goToStepDigital(financialModel, type, onlyLocal, financialModel.taskFiliale, 2)
              .then(function (newFinancialModel) {
                self.progressBar =
                  newFinancialModel.frontEndOptions.progressBar;
                self.enabled.enabledBack = !newFinancialModel
                  .frontEndOptions.disabledBack;
                self.enabled.enabledSave = !newFinancialModel
                  .frontEndOptions.disabledSave;
                self.actionBar =
                  newFinancialModel.frontEndOptions.actionBar;
                financialModel = Object.assign(
                  FinancialModel.build({}),
                  newFinancialModel
                );
                self.loading.backStep = false;
                $rootScope.disableDoubleClick = false;
                self.restgoToStepDigitalFinish = true;
              })
              .catch(function () {
                self.loading.backStep = false;
                $rootScope.disableDoubleClick = false;
                self.restgoToStepDigitalFinish = true;
              });

          }
        };

        var uploadFile = {
          pippo: this,
          uploadData: null,
          uploadDocumenti: null,
          visualProgBarDoc: false,
          progresso: 0,
          uploader: new FileUploader({
            url: "",
            headers: {
              "Access-Control-Allow-Origin": "*",
              Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
              "App-Name": $rootScope.portalName,
            },
            onAfterAddingFile: function (fileItem) {
              var self = this;
              console.log("fileItem", fileItem);
              uploadFile.progresso = 0;
              if (fileItem.file.size > 26214400) {
                $rootScope.$broadcast("addAlert", {
                  text: "MAXIMUM_FILE_SIZE_EXCEEDED",
                });
                fileItem.remove();
                jQuery("#uploadInput_document").val("");
              }
              var fileName = fileItem.file.name;
              if (
                fileName.toLowerCase().indexOf(".png") > -1 ||
                fileName.toLowerCase().indexOf(".jpg") > -1 ||
                fileName.toLowerCase().indexOf(".jpeg") > -1 ||
                fileName.toLowerCase().indexOf(".tiff") > -1 ||
                fileName.toLowerCase().indexOf(".pdf") > -1 ||
                fileName.toLowerCase().indexOf(".p7m") > -1
              ) {
                self.queue[0].progress = 100;

                uploadFile.visualProgBarDoc = true;

                $timeout(function () {
                  uploadFile.progresso = 100;
                }, 500);
              } else {
                fileItem.remove();
                jQuery("#uploadInput_document").val("");
                $rootScope.$broadcast("addAlert", {
                  text: "FORMAT_NOT_SUPPORTED",
                });
              }
            },
            onAfterAddingAll: function (addedFileItems) {
              var self = this;
              console.info("onAfterAddingAll", addedFileItems);
              uploadFile.finalUpload(self.uploadData);
            }
          }),
          uploadDataFunc: function (item, index) {
            var self = this;
            var document =
              arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            self.checkAdv = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            if (item) {
              self.uploadData = item;
            }
            self.uploadDocumenti = document;
            console.log("uploader", self.uploader);
            console.log("Testami", getModelQuestAdv());
          },
          finalUpload: function () {
            var self = this;
            console.log("faccio finalmente partire l'upload");
            if (self.checkAdv == 'checkAdv') {
              var filesUpload = document.querySelector("#uploadInput_documentAdv").files;
              filesUpload = Object.keys(filesUpload).map(function (key) {
                return filesUpload[key];
              });
              var formData = new FormData();
              jQuery("#uploadInput_documentAdv").val("");
              var model = getModel();
              console.log(model);
              filesUpload.forEach(function (file) {
                formData = new FormData();
                appendToForm(formData, "file", file);
                appendToForm(formData, "filename", file.name);
                appendToForm(formData, "idPratica", getModelQuestAdv().id);
                $financialApiService
                  .uploadDocStatSocOnAdv(formData)
                  .then(function (response) {
                    if (response.success) {
                      $timeout(function () {
                        var tmp = {
                          filename: file.name,
                          id: response.id,
                          cdDoc: self.uploadDocumenti.cdDocNsil,
                          downloadKey: response.downloadKey
                        };

                        self.visualProgBarDoc = false;
                        getResponseValidateADV().uploadDoc.uploadedFiles.push(tmp);
                      }, 1);
                    } else {
                      self.visualProgBarDoc = false;
                    }
                  })
                  .catch(function (error) {
                    self.visualProgBarDoc = false;
                  });

              });

            } else {
              var filesUpload = document.querySelector("#uploadInput_document").files;
              filesUpload = Object.keys(filesUpload).map(function (key) {
                return filesUpload[key];
              });
              var formData = new FormData();
              jQuery("#uploadInput_document").val("");
              var model = getModel();
              console.log(model);
              filesUpload.forEach(function (file) {
                formData = new FormData();
                appendToForm(formData, "file", file);
                appendToForm(formData, "type", "FINANCIAL");
                appendToForm(formData, "ndgCliente", model.financialCustomer.metadata.riUserG.ndg);
                appendToForm(formData, "filename", file.name);
                appendToForm(formData, "idPratica", model.leasingData.id);
                appendToForm(formData, "numeroAnno", model.leasingData.preventivo.anno);
                appendToForm(formData, "numeroContratto", model.leasingData.contratto.numero);
                appendToForm(formData, "modulo", model.leasingData.contratto.modulo);
                appendToForm(formData, "numeroPreventivo", model.leasingData.preventivo.numero);
                appendToForm(formData, "cdDoc", self.uploadDocumenti.cdDocNsil);
                appendToForm(formData, "idDocNsil", self.uploadDocumenti.idDocNsil);
                appendToForm(formData, "cfClient", model.financialCustomer.metadata.riUserG.cf);

                $financialApiService
                  .uploadDocOnDigital(formData)
                  .then(function (response) {
                    if (response.success) {
                      $timeout(function () {
                        var tmp = {
                          filename: file.name,
                          id: response.id,
                          cdDoc: self.uploadDocumenti.cdDocNsil,
                        };

                        self.visualProgBarDoc = false;
                        getCheckRichiesta().uploadDoc.uploadedFiles.push(tmp);
                      }, 1);
                    } else {
                      self.visualProgBarDoc = false;
                    }
                  })
                  .catch(function (error) {
                    self.visualProgBarDoc = false;
                  });
              });
            }
          },
          check: function (el) {
            el.isSelected = !el.isSelected;
          },
          generateDownloadLink: function (file) {
            return (
              $configService.getUrl() +
              "/uni/downloadGenericDigital/service-infos/FINANCIAL/" +
              encodeURIComponent(file.cdDoc) +
              "/" +
              encodeURIComponent(file.id) +
              "/" +
              encodeURIComponent(getModel().idWfInstance) +
              "/?token=" +
              $configService.getAppConfig().token
            );
          },
          genericTrashCheck: function () {
            return (
              getCheckRichiesta().uploadDoc &&
              getCheckRichiesta().uploadDoc.uploadedFiles &&
              getCheckRichiesta().uploadDoc.uploadedFiles.some(function (element) {
                return element.isSelected == true;
              })
            );
          },
          genericTrashCheckAdv: function () {
            return (
              getResponseValidateADV().uploadDoc &&
              getResponseValidateADV().uploadDoc.uploadedFiles &&
              getResponseValidateADV().uploadDoc.uploadedFiles.some(function (element) {
                return element.isSelected == true;
              })
            );
          },
          deletePrivacyDocument: function (type) {
            var self = this;
            self.progresso = 100;
            self.visualProgBarDoc = true;

            $timeout(function () {
              self.progresso = 0;
            }, 200);

            if (type == 'adv') {
              self.documentsToBeDeleted = getResponseValidateADV().uploadDoc.uploadedFiles
                .filter(function (elem) {
                  return elem.isSelected == true;
                });

            } else {
              self.documentsToBeDeleted = getCheckRichiesta().uploadDoc.uploadedFiles
                .filter(function (elem) {
                  return elem.isSelected == true;
                });

            }



            var documentRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            self.documentsToBeDeleted.forEach(function (element) {

              $simulationService
                .deleteChecklistFileDigital(element.id)
                .then(function (response) {
                  console.log(response);
                  $timeout(function () {
                    self.visualProgBarDoc = false;
                    if (type == 'adv') {
                      getResponseValidateADV().uploadDoc.uploadedFiles = getResponseValidateADV().uploadDoc.uploadedFiles
                        .filter(function (e) {
                          return e.isSelected != true;
                        });
                    }
                    else {
                      getCheckRichiesta().uploadDoc.uploadedFiles = getCheckRichiesta().uploadDoc.uploadedFiles
                        .filter(function (e) {
                          return e.isSelected != true;
                        });
                    }

                  }, 1);
                })
                .catch(function (error) {
                  $rootScope.$broadcast("addAlert", {
                    text: "ERROR_TEC",
                  });
                  self.visualProgBarDoc = false;

                });
            })

          }
        }

        var populateFinancialVendor = function (vendorResponse) {
          financialModel.financialVendor.mansioni = vendorResponse.mansioni;
          financialModel.financialVendor.reteVendita =
            vendorResponse.reteVendita;
          financialModel.financialVendor.mansioneAziendale =
            vendorResponse.mansioneAziendale;
          financialModel.financialVendor.descUnitaOrganizzativa =
            vendorResponse.descUnitaOrganizzativa;
          financialModel.financialVendor.cdUnitaOrganizzativa =
            vendorResponse.cdUnitaOrganizzativa;
          financialModel.financialVendor.clientManager =
            vendorResponse.clientManager;
          financialModel.financialVendor.segnalatori =
            vendorResponse.segnalatori;
          financialModel.financialVendor.codAnagAlternativi = vendorResponse.codAnagAlternativi;
          if (vendorResponse.riUserG.listino) {
            financialModel.financialVendor.riUserG.listino.ndgListino =
              vendorResponse.riUserG.listino.ndgListino;
            financialModel.financialVendor.riUserG.listino.prodotti =
              vendorResponse.riUserG.listino.prodotti;
            financialModel.financialVendor.sazAttivo = vendorResponse.sazAttivo;
            if (vendorResponse.soggettiSubordinati) {
              financialModel.financialVendor.soggettiSubordinati =
                vendorResponse.soggettiSubordinati;
            }
            if (vendorResponse.soggettiSubordinanti) {
              financialModel.financialVendor.soggettiSubordinanti =
                vendorResponse.soggettiSubordinanti;
            }
            if (vendorResponse.accountFunzionale) {
              financialModel.financialVendor.accountFunzionale =
                vendorResponse.accountFunzionale;
            }
          }
          if (vendorResponse.filiale) {
            financialModel.financialVendor.filiale = vendorResponse.filiale;
          }
          financialModel.financialVendor.riUserG.ragioneSociale =
            vendorResponse.riUserG.ragioneSociale;
          financialModel.financialVendor.ragioneSociale =
            vendorResponse.riUserG.ragioneSociale;
        };

        var checkGaranti = function () {
          var mostraModale = false;
          var numGaranzie = financialModel.leasingData.preventivo.garanzie.length;
          var listaGar = [];
          var listaGarFirSelected = [];

          financialModel.financialCustomer.metadata.riUserF.listaPf.forEach(function (element) {
            if (element.garante.selected) {
              listaGar.push(element.cf);
            }
          });

          financialModel.financialCustomer.metadata.aziendeGaranti.forEach(function (element) {
            listaGar.push(element.cf);
            //verifico se è stato selezionato un firmatario
            if (element.cfFirmatario != null) {

            }
          });
          //se non ci sono garanzie selezionate ma sono presenti garanti
          if (numGaranzie == 0 && listaGar.length > 0) {
            mostraModale = true;
            //se sono presenti garanzie, verifico e c'è qualche garante non associato ad una garanzie 
          } else if (numGaranzie > 0) {
            financialModel.leasingData.preventivo.garanzie.forEach(function (element) {
              element.listaGaranti.forEach(function (el) {
                if (el.garante.selected) {
                  var isSelected = listaGarFirSelected.some(function (sel) {
                    return el.cfGarante == sel.cf
                  });
                  if (!isSelected) {
                    populateListaGarFir(listaGarFirSelected, el.cfGarante);
                  }
                }
              });
            });

            listaGar.sort();
            listaGarFirSelected.sort();
            var is_same = (listaGar.length == listaGarFirSelected.length) && listaGar.every(function (element, index) {
              return element === listaGarFirSelected[index];
            });
            mostraModale = !is_same;
          }

          return mostraModale;
        }

        self.checkCF = function (listaGarFirSelected, cf) {
          return listaGarFirSelected.some(function (element) {
            return element == cf
          })
        }

        var populateListaGarFir = function (listaGarFirSelected, cfPiva) {
          if (listaGarFirSelected.length == 0) {
            listaGarFirSelected.push(cfPiva);
          } else {
            //prima di aggiungere l'elemento alla lista verifico che non sia presente
            if (!self.checkCF(listaGarFirSelected, cfPiva)) {
              listaGarFirSelected.push(cfPiva);
            }
          }
        }

        var isDataOK = function () {
          var self = this;
          self.visualSuspendButton = self.getPageIndex() > 2 ? true : false; // non più utilizzato viene gestito dal BE
          self.visualBackButton = self.getPageIndex() > 0 ? true : false; // non più utilizzato viene gestito dal BE
          self.backStepEnabled = true; // la visualizzazione del back viene gestita dal BE quindi ogni volta che compare deve esere abilitato

          switch (self.getWizardMap(self.getPageIndex())) {
            case "M1":
              return (
                FinancialVendor.build(self.getModel().financialVendor).isOk(
                  true,
                  false
                ) ||
                Bank.build(self.getModel().bank).isOk(true) ||
                FinancialVendor.build(self.getModel().financialVendor).isOk(
                  false,
                  true
                )
              );
            case "M2":
              //checkMapCustomerSelection
              return (
                !!financialModel.financialCustomer && enableFinancialCustomer
              );
            case "M4":
              //checkMapClientData
              return enableClientData;
            case "M5":
              return enableLeasingHypothensis; //self.getModel().financialCustomer.isOk();
            case "M6":
              //checkMapFinancialData
              return enableFinancialData; //self.getModel().financialData.isOk();
            case "D1":
              return enableDerogationsManage;
            case "RP":
              //checkAcceptance
              return FinancialCustomer.build(
                self.getModel().financialCustomer
              ).isOk(false, false, true, false, false, false, false);
            case "M13a":
              //checkPolizzaVenditaDistanza
              return FinancialCustomer.build(
                self.getModel().financialCustomer
              ).isOk(false, false, false, true, false, false, false);
            case "M13b":
              //checkMapQuestionarioQva
              return FinancialCustomer.build(
                self.getModel().financialCustomer
              ).isOk(false, false, false, false, true, false, false);
            case "M12":
              //checkMapLeasingRequest
              return (
                LeasingData.build(self.getModel().leasingData).isOk(
                  true,
                  false
                ) &&
                enableButtonCheckContacts &&
                enableButtonFatturazione &&
                enableButtonCespite &&
                enableButtonIban &&
                enableButtonTax &&
                enabledCcs &&
                !!self.getModel().financialCustomer.metadata.categoria &&
                !!self.getModel().financialCustomer.metadata.codiceCategoria &&
                !!self.getModel().financialCustomer.metadata.modalitaInvioDocumentazione
              );
            case "M14":
              //checkMapAppropriateVerification
              if (!$configService.getAppConfig().envData.newAdvEnabled) {
                return (
                  FinancialCustomer.build(self.getModel().financialCustomer).isOk(
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true
                  ) &&
                  enableButtonIbanAuth &&
                  enableButtonAdvSubject
                );
              } else {
                return valueForEnabledNextButton;
              }
            case 12:
              //checkList
              return true;
            case "M11":
              return enableCorporateData;
            case "M10":
              return enableButtonCheckList;
            case "MP1":
              //checkMapTariffaPlafond
              return (
                LeasingData.build(self.getModel().leasingData).isOk(
                  false,
                  true
                ) && enableButtonClientiDest
              );
            case "MP2":
              //checkMapSettingProductsRange
              return enableSettingProductsRange;
            case "M15":
              //checkMapGoodManagement
              return enableGoodManagement || enableAliquota;
            case "M9":
              return enableRatingCgs;
            case "M8":
              return enableNuovoPrestoLeasing;
            case "M7":
              return enableButtonRiskCourse;
            case "M16":
              return enableNpl;
            case "M17":
              return enableButtonInContractSignaturePage;
            case "BEI11":
              return $portalService.isAru() ? enableFondiBei : true;
            case "MPL":
              return enableMPLPage;
            case "DNPL":
              return enableDNPLPage;
            default:
              return enalbeMPLPage;
          }
        };



        return {
          /**
           * Use this to retrieve the process model
           */
          initModel: initModel,
          getModel: getModel,
          setModel: setModel,
          getWizardMap: getWizardMap,

          somethingLoading: function () {
            return navigator.somethingLoading();
          },

          getPageIndex: function () {
            return navigator.getPageIndex();
          },

          back: function () {

            navigator.loading.backStep = true;
            $workflowService.checkConcurrence(getModel().idWfInstance)
              .then(function (response) {
                if (response.success) {
                  return navigator.back();
                } else {
                  navigator.loading.backStep = false;
                }
              })
              .catch(function (error) {
                console.log(error);
                navigator.loading.backStep = false;
              })
          },

          next: function (fromModal, typeOfModal) {
            if (fromModal) {
              return navigator.nextPage(fromModal, typeOfModal);
            } else {
              navigator.loading.nextStep = true;
              $workflowService.checkConcurrence(getModel().idWfInstance)
                .then(function (response) {
                  if (response.success) {
                    return navigator.nextPage(fromModal, typeOfModal);
                  } else {
                    navigator.loading.nextStep = false;
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  navigator.loading.nextStep = false;
                })
            }
          },

          pause: function (fromModal) {
            navigator.loading.suspend = true;
            if (fromModal) {
              return navigator.suspend();
            } else {
              $workflowService.checkConcurrence(getModel().idWfInstance)
                .then(function (response) {
                  if (response.success) {
                    $modalService.openModal('suspendInstance');

                  }
                  navigator.loading.suspend = false;
                })
                .catch(function (error) {
                  console.log(error);
                  navigator.loading.suspend = false;
                })
            }
          },

          goHome: function (typeOfModal) {
            return navigator.goToHomePage(typeOfModal);
          },

          preventiveAccept: function (nameModal) {
            return navigator.sendPreventiveAccept(nameModal);
          },

          getNuovoPrestoLeasingResolution: function (modalClose, printBackground) {
            self.restCalled = true;
            return navigator.sendRequestToGetNuovoPrestoLeasingResolution(modalClose, printBackground);
          },

          sendResolution: function () {
            return navigator.sendResolution();
          },

          rejectArcAssurances: function () {
            return navigator.sendRequestToRejectArcAssurances();
          },

          goToAnagCli: function () {
            return navigator.goToAnagCliFn();
          },

          openModal: function () {
            var financialModel = getModel();
            $transactionFactory.set(financialModel);
            $rootScope.openModalViewDocs = true;
            $timeout(function () {
              $modalService.openModal("viewDocuments");
            }, 100);
          },

          closeModal: function (value) {
            var self = this;
            self.navigator.loading.nextStep = false;
            $modalService.closeModal(value);
          },

          setFilterIsPresent: function (value) {
            filtersIsPresent = value ? true : false;
          },

          getFilterIsPresent: function () {
            return filtersIsPresent;
          },

          generateDownloadLinkDocumentation: function (id) {
            return $configService.getUrl() +
              "/uni/downloadGenericDigital/service-infos/FINANCIAL_PD/" +
              "null/" +
              "/" +
              encodeURIComponent(id) +
              "/" +
              encodeURIComponent(financialModel.idWfInstance) +
              "/?token=" +
              $configService.getAppConfig().token
          },

          generateDownloadLink: function () {
            var input = {}
            var url = "/uni/download/service-infos/GUIDA_UPLOAD_ADV/"
            $download.getGenericDownload(url, input)
              .then(function (response) {
                console.log(response)
              })
          },

          isDataOK: isDataOK,
          validateFinancialData: validateFinancialData,
          validateLeasingHypothesis: validateLeasingHypothesis,
          getChecDeroga: getChecDeroga,
          setChecDeroga: setChecDeroga,
          validateSettingProductsRange: validateSettingProductsRange,
          validateCorporateData: validateCorporateData,
          setAcceptMode: setAcceptMode,
          getAcceptMode: getAcceptMode,
          getPortalName: getPortalName,
          validateGoodManagement: validateGoodManagement,
          getCheckRichiesta: getCheckRichiesta,
          setCheckRichiesta: setCheckRichiesta,
          navigator: navigator,
          validateFinancialCustomer: validateFinancialCustomer,
          validateCheckList: validateCheckList,
          validateNuovoPrestoLeasing: validateNuovoPrestoLeasing,
          validateCheckContacts: validateCheckContacts,
          validateFatturazione: validateFatturazione,
          validateDerogationsManage: validateDerogationsManage,
          submitDeroga: submitDeroga,
          setNoteAlba: setNoteAlba,
          getNoteAlba: getNoteAlba,
          getSearchMode: getSearchMode,
          setSearchMode: setSearchMode,
          validateCespite: validateCespite,
          validateRatingCgs: validateRatingCgs,
          setLoader: setLoader,
          getLoader: getLoader,
          setEnabledButtons: setEnabledButtons,
          getEnabledButtons: getEnabledButtons,
          submitRating: submitRating,
          submitRichiestaPlafond: submitRichiestaPlafond,
          modelQuestionarioBei: modelQuestionarioBei,
          validateClientData: validateClientData,
          validateNpl: validateNpl,
          validateDnpl: validateDnpl,
          validateContractSignaturePage: validateContractSignaturePage,
          gotoHomeWithFilter: gotoHomeWithFilter,
          validityFondiBei: validityFondiBei,
          setFondiBei: setFondiBei,
          getFondiBei: getFondiBei,
          validateAliquota: validateAliquota,
          getListOfDocumentNotUploaded: getListOfDocumentNotUploaded,
          setListOfDocumentNotUploaded: setListOfDocumentNotUploaded,
          validateRecClient: validateRecClient,
          userInfo: userInfo,
          validateIbanAuth: validateIbanAuth,
          validateAdvSubject: validateAdvSubject,
          valueOfQuestADV: valueOfQuestADV,
          getCheckGarante: getCheckGarante,
          setCheckGarante: setCheckGarante,
          setQvaInfo: setQvaInfo,
          getQvaInfo: getQvaInfo,
          changeRadioAction: changeRadioAction,
          validateTax: validateTax,
          validateCcs: validateCcs,
          validateIban: validateIban,
          backgroundPrint: backgroundPrint,
          validateBancaPrestoLeasing: validateBancaPrestoLeasing,
          uploadFile: uploadFile,
          setResponseSubmitLoadContract: setResponseSubmitLoadContract,
          getResponseSubmitLoadContract: getResponseSubmitLoadContract,
          setResponsecheckSubmitDelBanca: setResponsecheckSubmitDelBanca,
          getResponsecheckSubmitDelBanca: getResponsecheckSubmitDelBanca,
          setShowHideNextButton: setShowHideNextButton,
          getShowHideNextButton: getShowHideNextButton,
          setResponseValidateADV: setResponseValidateADV,
          getResponseValidateADV: getResponseValidateADV,
          getModelQuestAdv: getModelQuestAdv,
          enableNextRiskCourse: enableNextRiskCourse,
		  isSlimLeasing : isSlimLeasing
        };
      }
    );
})();